/**
 * @license
 * @qwik.dev/core 2.0.0-beta.45-dev+7854d56
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ve, isBrowser as ze } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { getAsyncLocalStorage as Be } from "@qwik.dev/core/async-local-storage";

export { getAsyncLocalStorage as _getAsyncLocalStorage } from "@qwik.dev/core/async-local-storage";

import { p as We } from "@qwik.dev/core/preloader";

const Ue = !1;

const He = (t, ...n) => Ye(!1, t, ...n);

const Je = (t, ...n) => Ye(!0, t, ...n);

const Ye = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const Ge = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ze = t => typeof t === "object" && t !== null;

const Ke = t => Array.isArray(t);

const tr = t => typeof t === "string";

const nr = t => typeof t === "function";

const er = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ye(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const rr = "2.0.0-beta.45-dev+7854d56";

const ir = "<sync>";

const sr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Md = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const or = "q:renderFn";

const lr = "q:componentHash";

const ur = "q:targetEl";

const cr = "⚡️";

const fr = "q:slot";

const ar = "q:sparent";

const hr = "q:s";

const dr = "[q\\:patch]";

const pr = "q:r";

const Nd = "q:rp";

const $r = "q:cc";

const yr = "q:style";

const wr = "style[q\\:style]";

const mr = wr + ",style[q\\:sstyle]";

const vr = "q:sstyle";

const br = "q:ctx";

const _r = "q:brefs";

const gr = (t, n) => t["qFuncs_" + n] || [];

const Er = "q:base";

const Sr = "q:container-island";

const kr = "/" + Sr;

const Rr = "q:ignore";

const Pr = "/" + Rr;

const Tr = "q:container";

const Ar = "/" + Tr;

const qr = "q:template";

const Ir = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Mr = "http://www.w3.org/1999/xhtml";

const xr = "http://www.w3.org/2000/svg";

const Nr = "http://www.w3.org/1998/Math/MathML";

const Cr = "qRender";

const Or = "q-e:qvisible";

const jr = "q:id";

const Lr = "q:key";

const Fr = "q:props";

const Xr = "q:seq";

const Dr = "q:seqIdx";

const Wr = "q:p";

const Vr = "q:ps";

const Ur = ":on";

const Br = ":onIdx";

const Qr = ":onFlags";

const Hr = ":cursorBoundary";

const Jr = ":nearestCursorBoundary";

const Yr = ":";

const Gr = "dangerouslySetInnerHTML";

const Kr = () => ({
    isServer: Ve,
    importSymbol(t, n, e) {
        if (Ve) {
            const t = Md(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw er(6, [ e ]);
        }
        if (!n) {
            throw er(14, [ e ]);
        }
        if (!t) {
            throw er(13, [ n, e ]);
        }
        const s = ti(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ti = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Er) ?? s, s);
    return new URL(e, o);
};

let ni = /*#__PURE__ */ Kr();

const ei = t => ni = t;

const ri = () => ni;

const xd = () => ni.isServer;

/*@__INLINE__*/ const ii = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const si = (t, n, e, s, o = !1) => {
    const r = ii(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const oi = (t, n, e) => {
    const s = ii(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const li = (t, n, e) => ii(t, n, e) >= 0;

const ui = t => t.nodeType === 1;

const ci = 100;

const fi = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const ai = (t, n, e) => {
    try {
        const s = t();
        return fi(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const hi = (t, n) => fi(t) ? t.then(n) : n(t);

const di = t => new Promise(n => {
    setTimeout(n, t);
});

const pi = t => {
    throw t;
};

function t(t, n = pi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!fi(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ci;
    const r = async e => {
        for (;fi(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!fi(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const $i = t => {
    const n = t.pn;
    return n || t;
};

const Cd = t => t.It;

const yi = Symbol();

class wi {
    [yi]=void 0;
}

const mi = "q:type";

const vi = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const gi = 124;

const Ei = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const Si = t => t === "foreignObject";

const ki = t => t === "svg" || Si(t);

const Ri = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Yr && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Pi = {
    elementNamespace: Mr,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Bl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Si(Bl(t));
    let o = Mr;
    let r = 0;
    const i = typeof n === "string" || dl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return ki(t);
        }
        if (dl(t)) {
            return ki(Bl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = xr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Ri(t);
        }
        if (dl(t)) {
            return Ri(Bl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Nr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? xr : e ? Nr : Mr;
        r = t.flags & 1536;
    }
    Pi.elementNamespace = o;
    Pi.elementNamespaceFlag = r;
    return Pi;
}

const Ti = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ai(t.slice(s, -1));
        }
    }
    return null;
}

const Ai = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = qi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const qi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ii = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

class Mi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [yi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class xi extends Mi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Ni extends xi {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Ci extends Mi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Oi = [];

const ji = [];

function i(t, n) {
    const e = $(n).priority;
    let s = Oi.length;
    for (let t = 0; t < Oi.length; t++) {
        const n = $(Oi[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Oi.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function s() {
    for (let t = 0; t < Oi.length; t++) {
        const n = Oi[t];
        let e = !1;
        for (let t = 0; t < ji.length; t++) {
            const s = ji[t];
            if (pu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    ji.push(t);
    c(t, n, !0);
    n.o++;
}

function l(t, n) {
    f(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    i(n, t);
}

function u(t, n, e) {
    const s = $(e);
    if (!s || s === n) {
        return;
    }
    c(e, t, !1);
    f(e, t);
    p(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function c(t, n, e) {
    e || (t.flags &= -257);
    const s = Oi.indexOf(t);
    if (s !== -1) {
        Oi.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = ji.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ji.length - 1;
    e !== s && (ji[e] = ji[s]);
    ji.pop();
    n.o--;
    return !0;
}

const Li = new WeakMap;

const Fi = ":nodeProps";

const Xi = ":nodeDiff";

const Di = ":errorData";

const Wi = ":signal";

const Vi = ":inlineComponentData";

const zi = new WeakMap;

function a(t, n) {
    let e = zi.get(t);
    e || zi.set(t, e = []);
    e.includes(n) || e.push(n);
}

function h(t) {
    const n = zi.get(t);
    n && zi.delete(t);
    return n;
}

function d(t, n, e) {
    n.position = e;
    e && $n(e) && function s(t, n, e) {
        const s = $(e);
        if (!s || s === n) {
            return;
        }
        c(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = h(n);
            if (s) {
                for (let n = 0; n < s.length; n++) {
                    a(t, s[n]);
                }
            }
            const o = n.extraPromises;
            if (o && o.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...o) : t.extraPromises = o;
            }
            p(t, n);
        })(n, s);
    }(t, n, e);
}

function p(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.pendingBoundary && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function $(t) {
    return Li.get(t) ?? null;
}

const Ui = Symbol();

const Bi = Symbol();

const Qi = Symbol();

const Hi = Symbol();

const Ji = Symbol();

const Yi = Symbol();

const Gi = [];

const Zi = {};

Object.freeze(Gi);

Object.freeze(Zi);

function y(t) {
    return new Proxy({}, new Ki(t));
}

class Ki {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ui) {
            return this.owner.constProps;
        }
        if (n === Bi) {
            return this.owner.varProps;
        }
        if (n === Qi) {
            return this.owner;
        }
        if (n === Hi) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = es(this.owner, n);
            n in this.owner.varProps && ts(this, n);
        }
        return e instanceof Os ? e.value : e;
    }
    set(t, n, e) {
        if (n === Qi) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === Ui) {
            this.owner.constProps = e;
        } else if (n === Bi) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Zi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                ns(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ns(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ui || n === Bi) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && ts(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ts = (t, n) => {
    const e = Gf();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.an;
    s && Cn(t.owner._proxy, n, t, s);
};

const ns = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && xu(t.$, t, e);
    return !!e;
};

const es = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const rs = (t, n) => is(t)?.[n] || ss(t)?.[n] || null;

const is = t => {
    if (!t) {
        return null;
    }
    return Bi in t ? "children" in t ? {
        ...t[Bi],
        children: t.children
    } : t[Bi] : t;
};

const ss = t => {
    if (!t) {
        return null;
    }
    return Ui in t ? t[Ui] : null;
};

const os = t => t && Bi in t;

const ls = Symbol();

class us {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

function w(t, n, e) {
    t[yi] || (Ve && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(_r, new Map) : t[yi] = new Map);
    const o = t[yi];
    let r = o.get(n);
    if (!r) {
        r = new us(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const hs = (t, n) => (e, s) => {
    const o = Xe();
    o.an = w(t, ":");
    o.$ = n || void 0;
    return je(o, () => {
        if (nr(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Tu(e)) {
            return e.value;
        }
        if (Ze(e) && zu(e)) {
            Cn(Xu(e), as, Fu(e), o.an);
            return e;
        }
        throw er(2);
    });
};

class ds {
    Xt;
    ft=void 0;
    $=null;
    $n=null;
    constructor(t, n) {
        this.$ = t || Gf()?.$ || null;
        this.Xt = n;
    }
    trigger() {
        xu(this.$, this, this.ft);
    }
    force() {
        xu(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Xt;
    }
    set untrackedValue(t) {
        this.Xt = t;
    }
    get value() {
        const t = this.untrackedValue;
        this.yn();
        return t;
    }
    yn() {
        const t = Gf();
        if (!t) {
            return;
        }
        this.$ === null && (this.$ = t.$);
        const n = t.an;
        if (n) {
            const e = Ve;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.pendingBoundary && e;
            Au(s, n);
            qu(n, this);
            if (e) {
                const e = Mu(t.$, this.$);
                o && e?.wn?.(this, n, null);
                Iu(n, e);
            }
        }
    }
    set value(t) {
        if (t !== this.Xt) {
            this.Xt = t;
            xu(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Xt
        };
    }
}

class ps {
    mn;
    vn=null;
    bn=!1;
    _n=!0;
    constructor(t, n, e) {
        this.mn = t;
        if (n !== void 0) {
            this.info = n;
            this.gn = e;
        }
    }
    get track() {
        if (!this.En) {
            const t = hs(this.mn, this.mn.$);
            this.En = (n, e) => {
                if (this.mn.Sn) {
                    throw er(39);
                }
                return t(n, e);
            };
        }
        return this.En;
    }
    get abortSignal() {
        const t = this.kn ||= new AbortController;
        this.bn && t.abort();
        return t.signal;
    }
    cache() {}
    get previous() {
        const t = this.mn.Xt;
        if (t !== ls) {
            return t;
        }
    }
    cleanup=t => {
        typeof t === "function" && (this.Rn ||= []).push(t);
    };
}

class $s extends ds {
    Dt;
    h;
    [yi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || Gf()?.$, ls);
        this.Dt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Xt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.zt = r;
            this.Ut = [];
        }
        s.timeout && (this.Bt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Xt = ls;
        this.h &= -129;
        this.invalidate();
    }
    invalidate(n) {
        if (this.Sn) {
            return;
        }
        if (arguments.length > 0) {
            this.Pn = n;
            this.gn = this.gn === void 0 ? 1 : this.gn + 1;
        }
        if (this.h & 512) {
            this.Tn(!0);
            return;
        }
        this.h |= 1;
        const e = Xe();
        e.$ = this.$ || void 0;
        const s = t(Le.bind(this, e, this.p));
        fi(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        try {
            return super.value;
        } catch (t) {
            !fi(t) && Gf()?.an?.consumer instanceof $s && this.yn();
            throw t;
        }
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.Pn = void 0;
            if (this.Ut) {
                for (let t = 0; t < this.Ut.length; t++) {
                    this.Ut[t]._n = !1;
                }
            } else {
                this.An && (this.An._n = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.An?.vn) {
            if (this.Xt === ls || Ve) {
                throw this.An?.vn;
            }
            return this.Xt;
        }
        if (this.Wt && this.Xt === ls) {
            throw this.Wt;
        }
        if (Ve && this.h & 64 && this.Xt === ls) {
            throw er(35);
        }
        return this.Xt;
    }
    set untrackedValue(t) {
        this.Xt = t;
    }
    get pending() {
        const t = this.qn() || !!(this.h & 64);
        let n = !1;
        try {
            t ? n = this.untrackedPending : this.p();
        } catch (e) {
            if (!fi(e) || t && Ve) {
                throw e;
            }
            n = t;
        }
        this.In();
        return n;
    }
    In() {
        const t = Gf();
        if (t && (this.$ ||= t.$ || null)) {
            const n = t.an;
            if (n) {
                Au(this.yt ||= new Set, n);
                qu(n, this);
                Iu(n, this.$);
            }
        }
    }
    set untrackedPending(t) {
        if (t !== !!this.Vt) {
            this.Vt = t;
            xu(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ve && this.An?.vn) {
            throw this.An?.vn;
        }
        return !!this.Vt;
    }
    get loading() {
        const t = this.untrackedPending;
        this.In();
        return t;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        this.Mn();
        if (t || !this.qn()) {
            return t;
        }
        return vs(this);
    }
    Mn() {
        const t = Gf();
        if (t && (this.$ ||= t.$ || null)) {
            const n = t.an;
            if (n) {
                Au(this.wt ||= new Set, n);
                qu(n, this);
                Iu(n, this.$);
            }
        }
    }
    set untrackedError(t) {
        if (t !== this.Wt) {
            this.Wt = t;
            xu(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ve && this.An?.vn) {
            throw this.An?.vn;
        }
        return this.qn() ? this.Wt : void 0;
    }
    qn() {
        return this.Xt !== ls || !!(this.h & 128);
    }
    Tn(t) {
        if (this.Sn) {
            return;
        }
        this.h |= 1;
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.An && this.xn(this.An, t);
    }
    vt() {
        if (!(this.h & 32) || this.Nn()) {
            return;
        }
        if (!ze) {
            return;
        }
        setTimeout(() => {
            this.Nn() || this.abort();
        });
    }
    async promise() {
        await t(() => this.p());
        for (;this.An?.vn; ) {
            await (this.An?.vn);
        }
    }
    p() {
        if (this.Sn || !(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Cn();
        }
        const n = this.Dt;
        Pu(n);
        const e = this.An;
        if (e && !e.bn) {
            e.bn = !0;
            e.kn?.abort();
            this.On(e);
        }
        const s = new ps(this, this.Pn, this.gn);
        this.An = s;
        const o = this.jn();
        let r;
        try {
            r = this.Ln(n.resolved, s);
        } catch (t) {
            if (fi(t)) {
                throw t;
            }
            s.gn === this.gn && (this.Pn = void 0);
            this.h &= -2;
            this.Fn(s, t);
            this.Xn(o);
            return;
        }
        if (fi(r)) {
            this.h |= 512;
            this.h &= -2;
            let n = r;
            const e = () => {
                const t = n ?? this.Ln(this.Dt.resolved, s);
                n = void 0;
                return t;
            };
            s.vn = this.Dn(s, () => t(e), o);
            return;
        }
        s.gn === this.gn && (this.Pn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = r;
        this.Xn(o);
    }
    jn() {
        return this.wt?.size ? ws(this) : void 0;
    }
    Xn(t) {
        if (!t) {
            return;
        }
        const n = ws(this);
        (n.size !== t.size || Array.from(t).some(t => !n.has(t))) && xu(this.$, this, this.wt);
    }
    Ln(t, n) {
        if (this.Sn) {
            throw er(39);
        }
        const e = t;
        if (this.h & 1024) {
            let t = Gf();
            t?.an && (t = {
                ...t,
                an: void 0
            });
            return Le(t, e, [ n ]);
        }
        const s = this.$ ||= Gf()?.$ || null;
        const o = w(this, ".");
        s && Tn(s, o);
        const r = Xe();
        r.$ = s || void 0;
        r.an = o;
        return Le(r, e, [ n ]);
    }
    Cn() {
        if (Ve && this.h & 64) {
            this.Vt = !0;
            this.$?.serializationCtx.xe.add(this);
            return;
        }
        this.h &= -2;
        const t = this.An;
        t && this.xn(t);
        const n = this.zt === 0 ? Infinity : this.zt ?? 1;
        if (this.Ut ? this.Ut.length >= n : t?.vn) {
            this.h |= 1;
            return;
        }
        const e = this.gn;
        const s = new ps(this, this.Pn, e);
        this.An = s;
        this.Ut && this.Ut.push(s);
        s.vn = this.Wn(s);
    }
    async Wn(n) {
        let e = this.Dt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Dt.resolve();
            if (this.Sn || n.kn?.signal.aborted) {
                n.vn = null;
                return;
            }
        }
        this.Bt && (this.Vn = setTimeout(() => {
            const t = Error(`timeout ${this.Bt}ms`);
            this.Fn(n, t);
            n.kn?.abort(t);
        }, this.Bt));
        return this.Dn(n, () => t(() => this.Ln(e, n)), this.jn());
    }
    async Dn(t, n, e) {
        try {
            const e = n();
            let s;
            if (fi(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.vn = null;
            if (t._n) {
                const n = this.Ut;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s]._n = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.vn = null;
            this.Fn(t, n);
        }
        if ((() => t === this.An)() && !this.Sn) {
            clearTimeout(this.Vn);
            t.gn === this.gn && (this.Pn = void 0);
            this.Xn(e);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    Fn(t, n) {
        if (t !== this.An || !t._n) {
            return;
        }
        t._n = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
    }
    $dispose() {
        if (this.Sn) {
            return;
        }
        this.Sn = !0;
        this.h &= -2;
        clearTimeout(this.Vn);
        this.$ && Pn(this.$, this);
        const t = new Set(this.Ut);
        this.An && t.add(this.An);
        for (const n of t) {
            n._n = !1;
            this.xn(n);
        }
    }
    async zn() {
        clearTimeout(this.Vn);
        const t = this.An;
        t && this.xn(t);
        this.Ut ? await Promise.all(this.Ut.map(t => t.vn)) : await (t?.vn);
    }
    Nn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    xn(t, n) {
        if (t.bn) {
            return;
        }
        t.bn = !0;
        t.kn?.abort(n);
        t.vn = hi(t.vn, () => this.Un(t));
    }
    On(t) {
        const n = t.Rn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    fi(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Un(t) {
        const n = () => {
            t.vn = null;
            const n = this.Ut;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.On(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const ys = (t, n) => {
    const e = t[yi];
    if (!e) {
        return !1;
    }
    for (const t of e.values()) {
        if (!t.backRef) {
            continue;
        }
        const e = Array.from(t.backRef);
        for (let s = 0; s < e.length; s++) {
            const o = e[s];
            if (o instanceof ds && o.ft?.has(t) && n(o)) {
                return !0;
            }
        }
    }
    return !1;
};

const ws = t => {
    const n = new Set;
    ys(t, t => {
        (t instanceof $s || t[yi]) && n.add(t);
        return !1;
    });
    return n;
};

const ms = (t, n, e) => ys(t, t => {
    if (n.has(t)) {
        return !1;
    }
    n.add(t);
    return t instanceof $s && e(t) || ms(t, n, e);
});

const vs = t => {
    let n;
    ms(t, new Set([ t ]), t => {
        t.Mn();
        n = t.Wt;
        return !!n;
    });
    return n;
};

const bs = t => (n, ...e) => t.call(null, Ma(n), ...e);

class _s extends $s {
    constructor(t, n) {
        super(t, n, 17);
    }
    Bn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Pu(this.Dt);
        const t = na(this.Dt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Xt === ls ? e : this.Xt;
        const r = ra(() => this.Bn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Bn = !0;
        this.h &= -2;
        const i = this.Bn && r !== "undefined" || r !== this.Xt;
        if (i) {
            this.Xt = r;
            xu(this.$, this, this.ft);
        }
    }
}

class gs extends $s {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Es = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Ss = (t, n) => new $s(n?.container || null, t, Cu(n?.serializationStrategy || "always"), n);

const ks = (t, n) => new gs(n?.container || null, t, Cu(n?.serializationStrategy || "always"), n);

const Rs = t => new _s(null, t);

const Ps = t => new ds(null, t);

const Ts = /*#__PURE__*/ bs(Ss);

const As = bs(Rs);

const qs = t => t.value;

const Is = (t, n) => t[n];

const Ms = t => {
    if (t.length === 1) {
        if (Tu(t[0])) {
            return t[0].$n ||= new Os(null, qs, t, null);
        }
        if (zu(t[0])) {
            return new Os(null, qs, t, null);
        }
        return t[0].value;
    }
    return new Os(null, Is, t, null);
};

const xs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ze(n)) {
        return n[e];
    }
    if (Tu(n)) {
        if (n instanceof Os) {
            return n;
        }
        return Ms(t);
    }
    if (os(n)) {
        const s = n[Ui];
        const o = n[Bi];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Ns(n, t);
        }
    } else {
        const s = Xu(n);
        if (s) {
            const n = s[e];
            return Ns(n, t);
        }
    }
    return n[e];
};

const Ns = (t, n) => Tu(t) ? t : Ms(n);

const Cs = (t, n) => {
    const e = xs(t, n);
    if (e === Ji) {
        return t[n];
    }
    return e;
};

class Os extends ds {
    ut;
    lt;
    Rt;
    h;
    _=void 0;
    [yi]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, ls);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, Wi, this);
                mn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            xu(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Xt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = ra(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Xt;
        if (n) {
            this.h |= 2;
            this.Xt = t;
        }
    }
    st() {
        return this.lt === qs && Tu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw er(31);
    }
    get value() {
        return super.value;
    }
}

class js {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Ls = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

Object.prototype.hasOwnProperty;

class Fs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Ls(n) ? Zi : n;
        this.constProps = !e || Ls(e) ? null : e;
    }
    get props() {
        return this._proxy ||= y(this);
    }
}

const Xs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Ds = t => t instanceof Fs;

const Ws = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ie(n);
        return Qf(s, () => {
            va(ba(s, t));
            return e();
        });
    }
    return e();
};

function m(t, n) {
    return Ws(this, n, () => {
        const t = ma[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function v(t, n) {
    return Ws(this, n, () => {
        const t = ma[0];
        t.value = n.checked;
    });
}

function b(t, n) {
    return Ws(this, n, () => {
        if (ma) {
            for (let t = 0; t < ma.length; t++) {
                const n = ma[t];
                n instanceof gs && n.h & 64 && n.p();
            }
        }
    });
}

const Vs = "bind:value";

const zs = "bind:checked";

const Us = "passive:";

const Bs = "preventdefault:";

const Qs = Object.prototype.hasOwnProperty;

const Hs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ai(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Js = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ai(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ai(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ai(t.slice(11, -1));
    }
    return null;
};

const Ys = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Js(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const Gs = (t, n, e, s, o, r, i) => new Fs(t, n, e, s, o, r, !1, i);

const Zs = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Us)) {
                    r.push(o);
                    t.add(Ai(o.slice(8)));
                } else {
                    o.startsWith(Bs) ? h.push(o) : Js(o) !== null ? s.push(o) : o === zs ? a = e[o] : o === Vs && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Us)) {
                    i.push(s);
                    t.add(Ai(s.slice(8)));
                } else {
                    s.startsWith(Bs) ? d.push(s) : Js(s) !== null ? o.push(s) : s === zs ? a = n[s] : s === Vs && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Hs(e, r, h, t, l);
            l = l || e !== n;
            e = Ys(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Hs(n, i, d, t, u);
            u = u || n !== e;
            n = Ys(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Qs.call(n, zs) && delete n[zs];
                if (e && Qs.call(e, zs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[zs];
                }
                n.checked = a;
                const t = Sa(null, "_chk", v, null, [ a ]);
                if (e && Qs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Xs(n, "q-e:input", t) || c;
                }
                c = Xs(n, "q-e:input", t) || c;
            } else if (f) {
                n && Qs.call(n, Vs) && delete n[Vs];
                if (e && Qs.call(e, Vs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Vs];
                }
                n.value = f;
                const t = Sa(null, "_val", m, null, [ f ]);
                if (e && Qs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Xs(n, "q-e:input", t) || c;
                }
                c = Xs(n, "q-e:input", t) || c;
            }
        }
        if (n && Qs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Qs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Fs(t, n, e, s, o, r, c || !0, i);
};

const Ks = (t, n, e, s) => ro(t, n, s);

const to = (t, n, e, s, o) => ro(t, {
    ...e,
    ...n
}, o);

const no = (t, n, e, s, o, r) => ro(t, {
    ...e,
    ...n,
    children: s
}, r);

const eo = t => t.children;

const ro = (t, n, e, s, o) => Zs(t, n, null, null, 0, e, o);

const io = ro;

const so = ro;

function _(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Zs(t, n, null, s.children, 0, o);
}

const oo = t => t.children;

const lo = (t, n) => new Fs(eo, null, null, t.children, 0, n);

const uo = t => Gs(eo, null, {
    [hr]: ""
}, t.children, 0, t.name ?? "");

const co = Symbol();

const fo = () => null;

const ao = () => null;

const ho = t => t.children;

const po = (t, n) => ro(lo, {
    children: ro($o, t)
}, n);

const $o = () => null;

let yo = null;

let wo = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    wo || (wo = t.setAttributeNS);
                    wo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            yo || (yo = t.setAttribute);
            yo.call(t, n, e);
        })(t, n, e);
    }
}

function E(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const mo = Object.prototype.hasOwnProperty;

const vo = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const bo = (t, n = [], e = {}) => {
    if (!Ze(t) || !os(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !vo.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[Ui];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Bi];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return y(new Fs(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && mo.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Os) {
            return ia(n, t, ":", e);
        }
    }
    return es(n, "name") || "";
}

const _o = t => cr + t;

const go = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + _o(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Eo = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const So = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const ko = t => {
    if (!t) {
        return "";
    }
    if (tr(t)) {
        return t.trim();
    }
    const n = [];
    if (Ke(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = ko(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Ro = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Po = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Ke(t)) {
            throw er(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Ro(e) + ":" + Ao(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const To = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = ko(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Po(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = To(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ao = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Eo.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class qo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Mo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class xo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class No {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Co = t => new qo(t);

const Oo = t => new Io(t);

const jo = (t, n) => new Mo(t, n);

const Lo = (t, n, e) => new xo(t, n, e);

const Fo = (t, n, e, s = null, o = !1) => new No(t, n, e, s, o);

const Xo = () => {
    const t = Kf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Xr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Xr, s);
    }
    let o = t.$.getHostProp(e, Dr);
    o === null && (o = 0);
    t.$.setHostProp(e, Dr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Do = t => {
    const n = nr(t) && !La(t) ? je(void 0, t) : t;
    return Ps(n);
};

const Wo = t => Vo(Do, t);

const Vo = (t, ...n) => {
    const {val: e, set: s} = Xo();
    if (e != null) {
        return e;
    }
    t = nr(t) && !La(t) ? na(t, ...n) : t;
    return s(t);
};

function T(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = I(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function A(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return vl(t, Hr, null) || null;
}

function q(t) {
    M(t, null);
}

function I(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return vl(t, Jr, null) || A(t);
}

function M(t, n) {
    __EXPERIMENTAL__.pendingBoundary && bl(t, Jr, n);
}

function x(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        x(s, A(s) || n);
    }
}

const zo = t => {
    if (t.zn) {
        try {
            t.zn();
        } catch (t) {
            He(t);
        }
        t.zn = null;
    }
};

function N(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const t = Ie(s);
        return Qf(t, () => N(n, e, s, ta(e, s, t)));
    }
    const r = o.$;
    const i = o._;
    Sl(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.k : null;
        const l = vl(i, Wr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = vl(i, Vr, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return Le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ie(n);
    return Qf(e, () => {
        const s = ta(t, n, e);
        typeof this === "string" && va(ba(s.$, this));
        const o = ma[0];
        return N(o, t, n, s);
    });
}

function O(t) {
    return t.R === t.T ? t.q : null;
}

function j(t) {
    return t.M || O(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = O(t);
    return e === o ? null : e;
}

const Uo = Object.prototype.hasOwnProperty;

function F(t, n, e, s, o, r) {
    bl(n, e, r);
    vn(t, Fo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function X(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        X: [],
        D: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        Z: 0,
        K: !0,
        tt: !1,
        nt: {
            et: new js({
                j: s,
                rt: !0
            }),
            it: new js({
                j: s,
                rt: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? X(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.X.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Bo = (t, n, e, s, o, r, i) => W(D(i, t, n, o, r), e, s);

const Qo = (t, n, e, s, o, r, i, c, l = !1, u) => W(D(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = Jl(e), o = null, r = !1) {
    V(t, n, e, s, o, r);
    const i = K(t);
    if (fi(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function V(t, n, e, s = Jl(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.Z; ) {
                if (typeof t.Y === "string") {
                    vt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    vt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (Ds(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.Y, n);
                            const e = t.Y.constProps && Uo.call(t.Y.constProps, Gr) || Uo.call(t.Y.varProps, Gr);
                            e ? t.W || nt(t, !1) : B(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === oo) {
                                rt(t);
                                $t(t, "F", t.Y.key);
                                B(t, t.Y.children, !0);
                            } else if (n === uo) {
                                rt(t);
                                G(t) || B(t, t.Y.children, !0);
                            } else if (n === gt) {
                                Y(t);
                                B(t, t.Y.children, !0, !0);
                            } else if (n === ao) {
                                et(t);
                            } else if (n === fo) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        B(t, t.Y, !1);
                    } else if (Tu(t.Y)) {
                        $t(t, "S", null);
                        const n = t.Y instanceof Os ? t.Y.st() : t.Y;
                        const e = t.M?.[yi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Os && (s = Nt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            B(t, z(t, () => ia(n, e, ".", t.$)), !0);
                        }
                    } else if (fi(t.Y)) {
                        $t(t, "A", null);
                        t.X.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === co || vt(t, "");
                }
                U(t);
            }
            et(t);
            Z(t);
            Q(t);
        }
    } finally {
        t.tt = i;
    }
}

function z(n, e) {
    try {
        return e();
    } catch (s) {
        if (fi(s)) {
            const o = s.then(() => t(e));
            n.X.push(o, n.W || n.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.G++;
    if (t.G < t.Z) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return Q(t);
    }
    t.W !== null ? t.W = null : t.M = L(t, t.M);
}

function B(t, n, e, s = !1) {
    if (!s && (n == null || e && Ke(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Jl(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Jl(t.R);
        t.W = null;
    }
    t.K = !1;
}

function Q(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.Z = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function H(t, n, e) {
    t.L.push(t.J, t.G, t.Z, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.Z = n.length;
        t.J = n;
        t.Y = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.Z = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.Z = 1;
    }
}

function J(t) {
    if (t.W) {
        return j(t);
    }
    return L(t, t.M) || O(t);
}

function Y(t) {
    const n = t.Y;
    const e = n.key;
    t.M = vl(t.R, e, n => Tl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = al();
        bl(t.W, fr, e);
        t.W.slotParent = t.R;
        bl(t.R, e, t.W);
    }
}

function G(t) {
    const n = t.Y;
    const e = gu(t.R);
    const s = R(e, n, t.$);
    const o = es(n, Hr) || null;
    const r = e ? vl(e, s, null) : null;
    if (r == null) {
        t.W = al();
        bl(t.W, fr, s);
        bl(t.W, Hr, o);
        x(t.W, o);
        e && bl(e, s, t.W);
        Dl(t.N, t.R, t.W, J(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        bl(t.W, fr, s);
        bl(t.W, Hr, o);
        x(t.W, o);
        e && bl(e, s, t.W);
        Xl(t.N, t.W);
        Dl(t.N, t.R, t.W, J(t));
        n && dl(n) && !n.firstChild && Bl(n) === qr && zl(t.N, n.parent, n, !0);
    }
    return !0;
}

function Z(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.$, t.N, e, t.O);
            zl(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function K(t) {
    for (;t.X.length; ) {
        const n = t.X.shift();
        const e = t.X.shift();
        if (fi(n)) {
            return n.then(n => {
                V(t, n, e);
                return K(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return K(t);
            });
        }
        V(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function tt(t) {
    t.N = null;
    t.O = null;
}

function nt(t, n = !0) {
    const e = t.M && Jl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        Ul(t.N, t.M, e, n);
    }
}

function et(t) {
    const n = O(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = L(t, t.M);
            if (t.R === n.parent) {
                kt(t.$, t.N, n, t.O);
                zl(t.N, t.R, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.M !== null && yl(t.M)) {
        const n = t.M;
        t.M = L(t, t.M);
        zl(t.N, t.R, n, !0);
    }
}

function it(t, n, e) {
    if (Tu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw er(15, [ e ]);
}

function st(n, e, s, o, r) {
    return t(() => ia(o, e, s, n, r));
}

function ot(t, n, e, s, o) {
    const r = t.j;
    const i = s.then(t => g(n, e, P(e, t, r), o));
    t.D.push(i);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Tr, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, s, o) {
    const r = function i(t, n) {
        const s = Vl(t.R, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.W = ul(i, n);
        t.W.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.W;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (Ti(n)) {
                ft(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && it(e, r, o)) {
                continue;
            }
            Tu(e) && (e = st(t.$, t.W, n, e, t.nt.et));
            if (fi(e)) {
                ot(t, r, n, e, l);
                continue;
            }
            if (n === Gr) {
                lt(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ut(r, e)) {
                continue;
            }
            g(r, n, P(n, e, t.j), l);
        }
    }
    const f = n.key;
    f && (t.W.key = f);
    if (t.j) {
        const e = Uo.call(n.varProps, "class") || n.constProps && Uo.call(n.constProps, "class");
        e || r.setAttribute("class", t.j);
    }
    Cl(t.N, t.R, t.W, j(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(N.bind(null, n));
                }
            } else {
                e && s.push(N.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = N.bind(null, n));
    }
    const i = r === "e:qvisible";
    (t.charAt(2) !== "e" || i) && _l(o.N, s, t, "");
    i || r === "d:qinit" || r === "d:qidle" ? a($(o.O), r) : gl(o.$, r);
}

function at(t, n, e) {
    if (t.tt) {
        ct(t, n, e, null);
    } else {
        const s = t.M && dl(t.M);
        const o = s && e === Bl(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.R) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || Sl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Uo.call(o, i) ? i.toLowerCase() : i;
            if (o && Uo.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    bl(n, l, null);
                    bl(n, i, e);
                }
                At(c, e) || Ho(t, n, i, c, s);
            } else {
                c != null && Ho(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Uo.call(e, r) || r.charAt(0) === ":" || Ti(r) || Ho(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Ho = (t, n, e, s, o) => {
    if (Ti(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === Wr || e === Vr) {
        bl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[yi]?.get(e);
    if (Tu(s)) {
        const o = s instanceof Os ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Tn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.nt.it);
    } else {
        i && Tn(t.$, i);
    }
    if (fi(s)) {
        const o = n;
        const i = s.then(n => {
            F(t.N, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    F(t.N, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = dl(o) ? Bl(o) : null;
                const r = bt(o) || _t(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = O(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = dl(i) ? Bl(i) : null;
                const r = bt(i) || _t(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = dl(t.M) ? Bl(t.M) : null;
                    const e = bt(t.M) || _t(t.M, t.$.k);
                    if (e != null) {
                        const s = ht(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = O(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = dl(s) ? Bl(s) : null;
                const e = bt(s) || _t(s, t.$.k);
                if (e != null) {
                    const o = ht(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Dl(t.N, o, t.W, j(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = bt(t.M) || _t(t.M, t.$.k);
                if (n != null) {
                    const e = dl(t.M) ? Bl(t.M) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Dl(t.N, o, n, j(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = bt(t.M);
    const r = t.M && wl(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Ol(t.N, t.R, t.W = al(), J(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.R, !0)) {
        Ol(t.N, t.R, t.W = al(), J(t));
        t.W.key = e;
    }
}

function yt(t, n) {
    const e = n[ja];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = _t(s, t.$.k);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                wt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.R)) {
                wt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = vl(s, Fr, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[Ui], e[Ui], e[Hi], s, !1);
                        o ||= t;
                        const r = Et(n[Bi], e[Bi], e[Hi], s, !0);
                        o ||= r;
                        e[Qi] = n[Qi];
                    } else if (n) {
                        bl(t, Fr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    wt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                bl(s, or, i);
                s.flags &= -33;
                mn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Fs(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            si(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Ds(n) && es(n, fr) || "") + "";
                const i = ii(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = _t(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            mt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.R) && mt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!wl(e) || vl(e, or, null) === null); ) {
                e = e.parent || gu(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Vi] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            mn(t.$, s, 8, t.O);
        }
    }
}

function wt(t, n, e, s) {
    n && Pn(t.$, n);
    Ol(t.N, t.R, t.W = al(), J(t));
    const o = t.Y;
    bl(t.W, or, e);
    bl(t.W, Fr, s);
    t.W.key = o.key;
}

function mt(t) {
    Ol(t.N, t.R, t.W = al(), J(t));
    const n = t.Y;
    bl(t.W, Fr, n.props);
    n.key && (t.W.key = n.key);
}

function vt(t, n) {
    if (t.M !== null) {
        const e = bu(t.M);
        if (e === 3) {
            if (n !== Ql(t.M)) {
                Hl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Cl(t.N, t.R, t.W = fl(document.createTextNode(n), n), j(t));
}

function bt(t) {
    if (t == null || yl(t)) {
        return null;
    }
    return t.key;
}

function _t(t, n) {
    if (t == null || yl(t)) {
        return null;
    }
    const e = vl(t, or, n);
    return e ? e.ot : vl(t, lr, null);
}

function gt() {}

function Et(t, n, e, s, o = !0) {
    if (St(t) && St(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === _r) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (n && i !== c && At(i, c)) {
                t[s] = c;
                continue;
            }
            if (!n || !At(i, c) && !qt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && It(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ns(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === _r) {
                continue;
            }
            if ((!t || !Uo.call(t, s)) && o) {
                delete n[s];
                const t = ns(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function St(t) {
    if (!t) {
        return !0;
    }
    return Ls(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    const r = s && $n(s) ? $(s) : null;
    if (yl(e)) {
        Tt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && $n(o) && u(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Pn(t, o);
            Tt(o);
            const r = c & 2 && vl(o, or, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Xr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ze(r)) {
                            const n = Ru(r);
                            if (n) {
                                Pn(t, r);
                                if (r.h & 1) {
                                    r.h |= 16;
                                    mn(t, o, 128, s);
                                    continue;
                                }
                                zo(r);
                            } else if (r instanceof $s || r instanceof Os) {
                                if (r.h & 4) {
                                    continue;
                                }
                                r instanceof $s ? r.$dispose() : Pn(t, r);
                            }
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Tl(t.rootVNode, e) : e;
                                let c = Jl(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Pt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = ml(o);
            if (i) {
                if (o === e) {
                    const n = Jl(o);
                    if (n) {
                        gn(n);
                        return;
                    }
                    Rt(t, o);
                }
            } else {
                const t = Jl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Tt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Rt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, fr);
    e != null && t.getHostProp(n.slotParent, e) === n && bl(n.slotParent, e, null);
}

function Pt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Bl(s) === qr) {
            Rt(t, e);
            zl(n, s, e, !0);
        }
    }
}

function Tt(t) {
    t.flags |= 32;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Os && n instanceof Os && xt(n, t);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Tu(t) && Tu(n)) {
        const e = t instanceof Os ? t.st() : t;
        const s = n instanceof Os ? n.st() : n;
        return na(() => e.value === s.value);
    }
    return !1;
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return Po(t) === Po(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return ko(t) === ko(n);
}

function xt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function Nt(t, n) {
    if (!(n instanceof Os)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Os && xt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Jo = (t, n, e, s, o) => {
    const r = Fe(t.cn, n, t);
    if (e) {
        r.an = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, or));
    if (sr(s)) {
        o = o || t.getHostProp(n, Fr) || Zi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (La(s)) {
        const t = s;
        i = () => Le(r, t, [ o || Zi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Le(r, t, [ o || Zi ]);
    }
    const l = Ve;
    const u = (e = 0) => ai(() => {
        if (!c) {
            t.setHostProp(n, Dr, null);
            t.setHostProp(n, Br, null);
        }
        e > 0 && hl(n) && Pn(t, n);
        return hi(i(o), t => hi(r.hn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ci) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Ur);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                return hi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const i in e) {
                        if (Object.prototype.hasOwnProperty.call(e, i)) {
                            let c = n;
                            let l = i;
                            if (s) {
                                if (i !== Or && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Xt();
                                    const n = Ve;
                                    n && t.ct(r) || (o = Ft(o, r));
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === Or && (l = "q-d:qinit");
                                Ot(c, l, e[i]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (fi(t) && e < ci) {
            return t.then(() => u(++e));
        }
        if (e >= ci) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ot(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ii(n);
    c && jt(t, f, "capture");
    l && jt(t, f, "preventdefault");
    u && jt(t, f, "stoppropagation");
}

function jt(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Zi && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Ds(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ke(t)) {
            n.push(...t);
        } else {
            if (fi(t)) {
                return hi(t, t => Lt(t));
            }
            if (Tu(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ft(t, n) {
    return Ke(t) ? [ ...t, n ] : [ t, n ];
}

function Xt() {
    return new Fs("script", null, {
        hidden: ""
    }, null, 0, ":useOn");
}

function Dt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Wt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Dt(t[c], c, r, s);
    }
    return i;
}

function Vt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function zt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Jl(e);
    const f = X(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Qo(c, n, Wt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Ul(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Qo(c, n, Wt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Ul(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            zl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Qo(c, n, Wt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            zl(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let A = d;
    let I = w;
    const M = () => {
        for (;A >= h; ) {
            const t = A - h;
            if (P[t] === 1) {
                I = g[S[t]];
                A--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = I === null ? e.lastChild === t : t.nextSibling === I;
                s || Dl(n, e, t, I);
                I = t;
                A--;
                continue;
            }
            let l = A;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = A - l + 1;
            const d = Qo(c, n, Wt(o, a, null, i, l, A), e, I, I, s, null, !0, f);
            return hi(d, () => {
                const t = Vt(e, I, u);
                I = t;
                A = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Xr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof ku) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Su(s, n, t);
                fi(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Bt(t, n) {
    const e = t.props ||= {};
    e[Xi] = n;
}

function Qt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Di] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Di] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = xl(n, document, r, e);
    const u = dl(r) && i || r;
    const f = u === r ? null : c;
    Cl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Xi];
    }(t);
    if (!r) {
        return;
    }
    Bt(t, null);
    Tu(r) && (r = r.value);
    return Bo(n, e, r, o, s, null);
}

function Jt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, or);
    if (r && !r.resolved) {
        return r.resolve().catch(n => {
            t.dirty &= -5;
            throw n;
        });
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Fr) || null;
    return Gt(n, o, o, r, i, e, s);
}

function Yt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Vi] || null;
        e && delete n[Vi];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Gt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Gt(n, e, s, o, r, i, c) {
    const l = ai(() => Jo(n, e, s, o, r), s => {
        const o = n.getHostProp(e, vr);
        return t(() => Bo(n, i, s, e, c, go(o)));
    }, t => {
        n.handleError(t, e);
    });
    if (fi(l)) {
        return l;
    }
    return;
}

function Zt(t, n, e, s, o, r = null) {
    n.push(Fo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Kt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Fi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Tu(e) && (e = e.value);
        const r = s.isConst;
        Zt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Fi];
    })(t);
}

function tn(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Xr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof ku && n.h & 16) {
            n.h &= -17;
            const t = n;
            zo(t);
        }
    }
}

function nn(n, e) {
    n.dirty &= -33;
    const s = e.getHostProp(n, Wi);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = Xe();
    r.$ = e;
    return hi(t(() => je.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return xu(e, s, o);
        }
    });
}

function en(t, n, e, s) {
    t.dirty &= -257;
    if (!__EXPERIMENTAL__.each) {
        return;
    }
    const o = t;
    const r = n.getHostProp(o, Fr) || null;
    if (!r) {
        return;
    }
    let i = rs(r, "items");
    Tu(i) && (i = na(i));
    const c = rs(r, "key$");
    const l = rs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return zt(n, e, o, s, i, u, f);
    }
    return hi(c.resolve(), t => hi(l.resolve(), r => zt(n, e, o, s, i, t, r)));
}

let Yo = null;

const Go = (t, n, e) => {
    Yo || (Yo = t.insertBefore);
    Yo.call(t, n, e);
};

function rn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Go(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Go(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof xo) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            Go(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof qo) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof Io) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof Mo) {
            c.target.nodeValue = c.text;
        } else if (c instanceof No) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (Zo(t, e)) {
                t[e] = Ko(o);
            } else if (e === Gr) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Tr, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const Zo = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Ko = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const tl = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.zn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const nl = (t => () => queueMicrotask(t))(ln);

const rl = tl(ln);

let il = !1;

function sn() {
    if (!il) {
        il = !0;
        nl();
    }
}

function on() {
    if (!il) {
        il = !0;
        rl();
    }
}

function ln() {
    il = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = s(); ) {
        if (un(e, n)) {
            on();
            return;
        }
    }
}

function un(t, n) {
    const e = Ve;
    const s = $(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        cn(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 1023)) {
            __EXPERIMENTAL__.pendingBoundary && q(u);
            d(i, s, hn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 128) {
                tn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -1024;
            d(i, s, hn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = Ut(u, i, s);
            } else if (u.dirty & 2) {
                e = Ht(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Jt(u, i, c, t);
            } else if (u.dirty & 8) {
                e = Yt(u, i, c, t);
            } else if (u.dirty & 256) {
                e = en(u, i, c, t);
            } else if (u.dirty & 16) {
                Kt(u, c);
            } else if (u.dirty & 32) {
                e = nn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 512 && Qt(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && fi(e)) {
            T(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                sn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    cn(i, t, s, e);
}

function cn(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        c(n, t);
        s || function o(t, n) {
            const e = $(t);
            const s = e.journal;
            if (s && s.length > 0) {
                rn(s);
                e.journal = null;
            }
            const o = h(e);
            if (o) {
                for (let t = 0; t < o.length; t++) {
                    gl(n, o[t]);
                }
            }
            (function r(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Su(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.pendingBoundary) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.pendingBoundary && t.props && Hr in t.props && bl(t, Hr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                fn(t);
            });
            return;
        }
        fn(t);
    }
}

function fn(t) {
    t.dt();
}

function an(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = hn(o[0], s, t);
    d(t, n, i);
    return i;
}

function hn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && dn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.pendingBoundary && q(s);
    return hn(s, n, e);
}

function dn(t, n) {
    if (!A(n)) {
        return !1;
    }
    $n(n) || pn(t, n, 0);
    return !0;
}

function pn(t, n, e) {
    if ($n(n)) {
        sn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Li.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    i(t, r);
    sn();
    return r;
}

function $n(t) {
    return (t.flags & 256) !== 0;
}

function yn(t, n) {
    if (!(n.flags & 1)) {
        let e;
        n.dirty & 16 && function s(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Fi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Tu(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && (e = nn(n, t));
        n.dirty &= -1024;
        return e;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Xr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof ku) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Su(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        fi(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            if (!__EXPERIMENTAL__.each) {
                return;
            }
            const e = n;
            const s = t.getHostProp(e, Fr) || null;
            if (!s) {
                return;
            }
            let o = rs(s, "items");
            Tu(o) && (o = na(o));
            const r = await rs(s, "key$").resolve();
            const i = await rs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const sl = [];

function wn(t) {
    for (let n = 0; n < sl.length; n++) {
        const e = sl[n];
        const s = sl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function mn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ve;
    }()) {
        const e = yn(t, n);
        fi(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            sl.push(n);
            let s = A(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = $n(o);
                __EXPERIMENTAL__.pendingBoundary && (s ||= A(o) || (t ? I(o) : null));
                if (o === e || t) {
                    M(n, s);
                    wn(o);
                    if (r) {
                        const t = $(o);
                        t.position !== o && (t.position = n);
                    }
                    sl.length = 0;
                    return;
                }
                if (r) {
                    const t = $(o);
                    t.position !== o && (t.position = n);
                }
                sl.push(o);
                o = o.slotParent || o.parent;
            }
            sl.length = 0;
            ((t, ...n) => {
                const e = Ye(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, A(n) || I(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if ($n(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = $(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        $n(n) ? M(n, A(n)) : function l(t) {
            sl.push(t);
            let n = A(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = $n(e);
                __EXPERIMENTAL__.pendingBoundary && (n ||= A(e) || (s ? I(e) : null));
                if (s) {
                    M(t, n);
                    wn(e);
                    sl.length = 0;
                    return !0;
                }
                sl.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            sl.length = 0;
            return !1;
        }(n) || pn(t, n, 0);
    }
}

function vn(t, n) {
    t.push(n);
}

const ol = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const ll = t => {
    let n = null;
    return e => {
        n || (n = ol(e, t));
        return n.call(e);
    };
};

const ul = (t, n, e = null) => {
    const s = new Ni(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const cl = t => {
    const n = new Ni(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const fl = (t, n) => {
    const e = new Ci(-4084, null, null, null, null, t, n);
    return e;
};

const al = () => {
    const t = new xi(null, -4094, null, null, null, null, null, null);
    return t;
};

const hl = t => t instanceof Mi;

const dl = t => (t.flags & 1) === 1;

const pl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const $l = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const yl = t => (t.flags & 4) === 4;

const wl = t => (t.flags & 2) === 2;

const ml = t => {
    const n = t.flags;
    return (n & 2) === 2 && vl(t, fr, null) !== null;
};

const Od = t => t;

const vl = (t, n, e) => {
    if (dl(t) || wl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const bl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const _l = (t, n, e, s, o = null) => {
    if (dl(n)) {
        bl(n, e, s);
        vn(t, Fo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const gl = (t, n) => {
    const e = window;
    e && (e._qwikEv ||= []).push(n);
};

const El = t => {
    if (t.key) {
        return;
    }
    const n = tu(t.node, Yr);
    n && (t.key = n);
};

const Sl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ti(c)) {
                bn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Yr && c) {
                if (c.startsWith(Tr)) {
                    const t = i.value;
                    t === "html" ? bl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && bl(e, "value", s.value);
                } else {
                    const t = i.value;
                    bl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        vl(e, Wr, null) === null && vl(e, Vr, null) === null || (n.flags |= 64);
    }
};

const kl = t => {
    if (t._t === "_run") {
        const n = t.getCaptured()?.[0];
        if (sr(n)) {
            return n;
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = kl(Xn(i[t], e));
        c.push(N.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function _n(t, n, e) {
    let s = Jl(n);
    for (;s; ) {
        if (yl(s)) {
            Pl(t, s);
            e(s, n);
        } else {
            dl(s) ? e(s, n) : _n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function gn(t) {
    let n = t;
    if (yl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Jl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Rl = (t, n, e) => {
    let s = t;
    for (;e && s && wl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !wl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !wl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (yl(t) && e && dl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && yu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Pl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Wl(n, !0);
        const o = e.node;
        const r = fu(s);
        let i = Rl(n, !1, !0);
        const c = Rl(n, !0, !0);
        const l = o || (c && dl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && yl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                vn(t, Lo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Rl(i, !1, !0);
        }
        i = n;
        for (;i && yl(i); ) {
            const n = Rl(i, !0, !0);
            const e = !n || !yl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    vn(t, jo(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    vn(t, Lo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Tl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const e = t.vNode;
        if (e) {
            return e;
        }
    }
    if (hl(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Il(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Ml(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = Al(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const Al = (t, n) => {
    let e = Jl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const ql = [];

const Il = (t, n) => {
    let e = Jl(t);
    for (;e && (!(e instanceof Ni) || e.node !== n); ) {
        if (wl(e)) {
            const t = e.nextSibling;
            const n = Jl(e);
            if (n) {
                t && ql.push(t);
                e = n;
            } else {
                e = t || (ql.length ? ql.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || ql.pop();
        }
    }
    for (;ql.length; ) {
        ql.pop();
    }
    return e;
};

const Ml = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const xl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = ul(o, "errored-host");
    if (pl(e)) {
        Dl(t, r, e, null);
    } else {
        const n = [];
        _n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Dl(t, r, n[e], null);
        }
    }
    return r;
};

const Nl = rn;

const Cl = (t, n, e, s) => {
    const o = dl(n);
    o && Yl(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Fl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Wl(n, !1);
    l && !c && vn(t, Lo(i, l, jl(t, n, s)?.node ?? null));
    Ll(n, e, s);
    c && (e.flags |= 32);
};

const Ol = (t, s, o, r) => {
    const i = dl(s);
    i && Yl(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Fl(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[ur] : null;
    const f = u ? null : i ? s : Vl(s, !1);
    const a = u || f?.node;
    const h = jl(t, s, r);
    const d = h?.node ?? null;
    const p = ml(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Vl(s, !1);
        const c = jl(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        _n(t, o, s => {
            if (yl(s)) {
                vn(t, Lo(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if (dl(c)) {
                                o = c.node;
                                const t = Bl(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Vl(l, !0);
                                if (h) {
                                    const t = e(h, Bl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Jl(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Zl(o)) {
                                    const t = Me(o);
                                    if (t) {
                                        const n = Jl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                vn(t, Lo(s.node, a, c));
            }
        });
    } else {
        a && !l && _n(t, o, n => {
            vn(t, Lo(n.node, a, d));
        });
    }
    Ll(s, o, r);
    l && (o.flags |= 32);
};

const jl = (t, n, e) => {
    let s = null;
    e == null ? wl(n) && (s = Rl(n, !0, !1)) : s = wl(e) ? Rl(e, !0, !0) : e;
    s && yl(s) && Pl(t, s);
    return s;
};

const Ll = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Fl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && zl(t, n, s, !1);
};

const Xl = (t, n) => {
    let e = n;
    for (;e && wl(e); ) {
        e = e.lastChild;
    }
    e && yl(e) && (e.flags & 8) === 0 && Pl(t, e);
};

const Dl = (t, n, e, s) => {
    pl(e) ? Cl(t, n, e, s) : Ol(t, n, e, s);
};

const Wl = (t, n) => {
    for (;t && !dl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[ur];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Vl = (t, n) => {
    for (;t && !dl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const zl = (t, n, e, s) => {
    yl(e) && Pl(t, e);
    if (s) {
        const s = vl(n, Gr, null) !== null;
        if (s) {
            return;
        }
        pl(e) ? vn(t, Co(e.node)) : _n(t, e, n => {
            vn(t, Co(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Ul = (t, n, e, s = !0) => {
    const o = Wl(n, !0);
    if (o && s) {
        if (pl(n)) {
            vn(t, Oo(n.node));
        } else {
            const e = Vl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? vn(t, Oo(o)) : _n(t, n, n => {
                vn(t, Co(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Bl = t => {
    const n = Od(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = cu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = uu(t);
            switch (n) {
              case xr:
                return 512;

              case Nr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Ql = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Hl = (t, n, e) => {
    Pl(t, n);
    n.text = e;
    vn(t, jo(n.node, e));
};

const Jl = t => {
    if (yl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.pendingBoundary && n === void 0 && dl(t) && function e(t) {
        const n = t.getAttribute(Nd);
        if (n === null) {
            return !1;
        }
        const e = lu(t);
        return _u(e) && e.localName === "template" && e.getAttribute(pr) === n && iu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Yl(t));
    return n;
};

const Yl = t => {
    const n = Od(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && Zl(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = lu(n);
            const s = fu(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                El(t);
                __EXPERIMENTAL__.pendingBoundary && n._qSegment;
                if (s) {
                    if (s.charCodeAt(0) === gi && s.charCodeAt(1) === gi) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = au(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = _u(t);
                            return !n || n && Rn(t);
                        };
                        let d = null;
                        hu(n, (p, $, y, w, m, b) => {
                            if (wu(p())) {
                                for (;h(s); ) {
                                    s = iu(s);
                                    if (!s) {
                                        throw er(27, [ n, p(), m ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;wu(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = cl(s);
                                    El(e);
                                    l(e);
                                    s = iu(s);
                                    for (;_u(s) && Rn(s); ) {
                                        s = iu(s);
                                        if (!s && t > 0) {
                                            throw er(27, [ n, p(), m ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                bl(t, vr, $());
                            } else if (p() === 60) {
                                const n = $();
                                if (n.charCodeAt(0) === 95) {
                                    bl(t, lr, decodeURIComponent(E(n.slice(1))));
                                } else {
                                    (d ||= []).push(t);
                                    bl(t, or, n);
                                }
                            } else if (p() === 61) {
                                a || (a = Ie(e));
                                const n = $();
                                a.Qn(parseInt(n, 10), t);
                            } else if (p() === 62) {
                                bl(t, Fr, $());
                            } else if (p() === 64) {
                                t.key = b();
                            } else if (p() === 91) {
                                bl(t, Xr, $());
                            } else if (p() === 94) {
                                bl(t, Dr, $());
                            } else if (p() === 96) {
                                a || (a = Ie(e));
                                Sn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Ie(e));
                                t.slotParent = Tl(a.rootVNode, $());
                            } else if (p() === 93) {
                                bl(t, br, $());
                            } else if (p() === 123) {
                                y();
                                l(al());
                                vu.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === gi) {
                                const n = $();
                                const e = decodeURIComponent(E(n));
                                const s = m + n.length + 1;
                                const o = w(s + 1) === gi;
                                let r;
                                if (o) {
                                    y();
                                    r = decodeURI(E($()));
                                    y();
                                } else {
                                    r = E($());
                                }
                                bl(t, e, r);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = vu.pop();
                                c = vu.pop();
                                i = vu.pop();
                                r = vu.pop();
                                t = vu.pop();
                            } else if (p() === 126) {
                                bl(t, fr, b());
                            } else {
                                for (;_u(s) && Rn(s); ) {
                                    s = iu(s);
                                }
                                const t = s && nu(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;mu(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new Ci(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Ie(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return au(t, e, void 0);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let Gl = null;

const Zl = t => {
    Gl || (Gl = t.hasAttribute);
    return Gl.call(t, Tr);
};

let Kl = null;

const tu = (t, n) => {
    Kl || (Kl = t.getAttribute);
    return Kl.call(t, n);
};

const nu = ll("nodeType");

const eu = t => {
    const n = nu(t);
    return n === 3 || n === 1;
};

let ru = null;

const iu = t => {
    ru || (ru = ol(t, "nextSibling"));
    ou || (ou = ol(t, "firstChild"));
    for (;t; ) {
        t = ru.call(t);
        if (t !== null) {
            const n = nu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Rr)) {
                    return En(t, Sr, ru, ou);
                }
                if (t.nodeValue?.startsWith(kr)) {
                    return En(t, [ Sr, Pr ], ru, ou);
                }
                if (n?.startsWith(Tr)) {
                    for (;t && (t = ru.call(t)) && (nu(t) !== 8 || !t.nodeValue?.startsWith(Ar)); ) {}
                }
            }
        }
    }
    return t;
};

function En(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = su(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const su = ll("parentNode");

let ou = null;

const lu = t => {
    ou || (ou = ol(t, "firstChild"));
    t = t && ou.call(t);
    if (t && nu(t) === 8) {
        ru || (ru = ol(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Rr)) {
            return En(t, Sr, ru, ou);
        }
    }
    for (;t && !eu(t); ) {
        t = iu(t);
    }
    return t;
};

const uu = ll("namespaceURI");

const cu = ll("nodeName");

const fu = ll("ownerDocument");

const au = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;_u(i) && Rn(i); ) {
            i = iu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = nu(i);
        let e = null;
        if (n === 3) {
            e = fl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = cl(i);
            El(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = iu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        hu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ie(t.node));
                const e = s();
                n.Qn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ie(t.node));
                Sn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function Sn(t, n, e) {
    if (t[yi]) {
        const s = t[yi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, yi, {
            get() {
                const s = e.k(n);
                t[yi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, yi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const hu = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    const u = () => {
        if (r(e + 1) !== gi) {
            return l();
        }
        c();
        const t = decodeURIComponent(E(l()));
        c();
        return t;
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e, u);
    }
};

const du = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Sl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Yr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const pu = (t, n) => {
    let e = $u(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = $u(e);
    }
    return !1;
};

const $u = t => t.parent || t.slotParent;

const yu = t => {
    if (t === null || wl(t)) {
        return null;
    }
    return t.node;
};

function kn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (dl(e)) {
                        const t = xe(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (yl(i)) {
            c.push(xn(Ql(i)));
        } else if (wl(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = du(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== mi && e !== "__scopedStyleIdPrefix__") {
                        const t = vl(i, e, null);
                        s.push(" " + e + "=" + xn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (vi[vl(i, mi, null) || "V"] || vi.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Jl(i);
            u && c.push("  " + kn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (dl(i)) {
            const s = Bl(i);
            const l = [];
            $n(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? du(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = vl(i, n, null);
                l.push(" " + n + "=" + xn(e));
            }
            const f = yu(i);
            if (f) {
                const t = fu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + xn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + xn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if ($l(i) || e) {
                const e = Jl(i);
                e && c.push("  " + kn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const wu = t => 48 <= t && t <= 57;

const mu = t => 97 <= t && t <= 122;

function Rn(t) {
    return !t.hasAttribute(Yr) || t.nodeName === "STYLE" && (t.hasAttribute(vr) || t.hasAttribute(yr));
}

const vu = [];

const bu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw er(26, [ n ]);
};

const _u = t => t && typeof t == "object" && nu(t) === 1;

const gu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!wl(t) || vl(t, or, null) === null); ) {
            const e = t.slotParent;
            const s = wl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Pn(t, n) {
    hl(n) && dl(n) && Yl(n);
    const e = n[yi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Tn(t, n);
    }
    e.clear();
}

function Tn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ds) {
            An(t, s, n);
            s instanceof $s && qn(s, n);
        } else if (os(s)) {
            const t = s[Hi];
            In(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Fu(e);
            In(o, n);
        }
    }
    e.clear();
}

function An(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Os && !s?.size) {
        n._ = void 0;
        Pn(t, n);
    }
}

function qn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function In(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Eu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = Xo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new ku(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {hn: u} = o;
    const f = hi(u, () => Su(c, l, o._));
    fi(f) && (o.hn = f);
};

const Su = (t, n, e) => {
    const s = t.Hn;
    if (s) {
        return s;
    }
    const o = t => {
        jf(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = hi(((t, n) => {
        const e = t.Jn;
        if (e) {
            return e;
        }
        const s = t.zn;
        if (!s) {
            return;
        }
        t.zn = null;
        try {
            const e = s();
            if (fi(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Jn === s && (t.Jn = void 0);
                });
                t.Jn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        t.h = t.h & -5 | 64;
        const s = Xe(n.cn, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => Pn(n, t));
        const c = hs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.zn = () => {
                            t.zn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    fi(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return ai(() => i(u), l, s => {
            if (fi(s)) {
                return s.then(() => {
                    t.Hn === r && (t.Hn = null);
                    return Su(t, n, e);
                }, o);
            }
            o(s);
        });
    });
    if (fi(i)) {
        r = i.finally(() => {
            if (t.Hn === r) {
                t.Hn = null;
                t.h & 4 && mn(n, e, 1);
            }
        });
        t.Hn = r;
        return r;
    }
    return i;
};

class ku extends wi {
    h;
    Ft;
    ht;
    bt;
    zn;
    Jn;
    Hn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Ft = n;
        this.ht = e;
        this.bt = s;
        this.zn = o;
    }
}

const Ru = t => t instanceof ku;

function Mn(t, n) {
    const e = Ie(n);
    return Qf(e, () => {
        typeof this === "string" && va(ba(e, this));
        const t = ma[0];
        if (!t.ht) {
            return;
        }
        if (t.h & 68) {
            return;
        }
        t.h |= 4;
        mn(e, t.ht, 1);
    });
}

const Pu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Tu = t => t instanceof ds;

const Au = (t, n) => {
    t.add(n);
};

const qu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Iu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Ru(e) ? o = e.bt : e instanceof $s ? o = e.Dt : s === ":" && (o = n.getHostProp(e, or));
        o && n.serializationCtx.Lt.add(o);
    }
};

const Mu = (t, n) => {
    if (t && (!n || t === n || Cd(t))) {
        return t;
    }
    return n;
};

const xu = (t, n, e) => {
    const s = ze;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Ru(o)) {
                o.h |= 4;
                mn(t, o.ht, 1);
            } else if (o instanceof ds) {
                o.invalidate();
            } else if (r === ":") {
                mn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Bt(o, n);
                    mn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof js) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Fi];
                            if (!o) {
                                o = new Map;
                                s[Fi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Fi);
                        if (!n) {
                            n = new Map;
                            t.setProp(Fi, n);
                        }
                        n.set(r, c);
                    }
                    mn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Nu = t => Ze(t) && typeof t[bf] === "function";

const Cu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Ou = t => {
    t.h |= 4;
};

const ju = [];

function xn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Ru(t)) {
            return `Task(${xn(t.bt)})`;
        }
        if (sr(t)) {
            return `Qrl(${t._t})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (ju.includes(t)) {
                return "*";
            }
            ju.length;
            try {
                ju.push(t);
                if (Array.isArray(t)) {
                    return hl(t) ? "(" + (vl(t, mi, null) || "vnode") + ")" : t.map(xn);
                }
                if (Tu(t)) {
                    return t instanceof Os ? "WrappedSignal" : t instanceof $s ? "ComputedSignal" : "Signal";
                }
                if (zu(t)) {
                    return "Store";
                }
                if (Ds(t)) {
                    return Lu(t);
                }
                if (hl(t)) {
                    return "(" + (vl(t, mi, null) || "vnode") + ")";
                }
            } finally {
                ju.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Lu = t => {
    if (Ds(t)) {
        if (typeof t.type === "function") {
            const n = t.type[ja];
            if (n) {
                const [t] = n;
                return "Component(" + t._t + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + xn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Lu(e);
                    }
                } else {
                    n += Lu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Fu = t => t[fs];

const Xu = t => {
    try {
        return t?.[cs] || null;
    } catch {
        return null;
    }
};

const Du = (t, n) => {
    const e = Fu(t);
    e && e.force(n);
};

const Wu = (t, n) => {
    const e = Fu(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Vu = t => Xu(t) || t;

const zu = t => cs in t;

function Nn(t, n, e) {
    return new Proxy(n, new Bu(e, t || null));
}

const Uu = (t, n, e) => {
    if (Ge(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = Nn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Bu {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Xu(this);
        xu(this.$, this, jn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === cs) {
                return t;
            }
            if (n === fs) {
                return this;
            }
            return t[n];
        }
        const e = Gf();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.an;
            o && Cn(t, Array.isArray(t) ? as : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ze(s)) {
            try {
                r = !Object.isFrozen(s) && !zu(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return Uu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Vu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && On(n, s, t, this);
        } else {
            On(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || xu(this.$, this, jn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === cs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Gf();
            if (e) {
                const s = e.an;
                s && Cn(t, Array.isArray(t) ? as : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Gf();
        const e = n?.an;
        e && Cn(t, as, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Cn(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ve;
    const l = __EXPERIMENTAL__.pendingBoundary && e instanceof Bu && c;
    Au(i, s);
    qu(s, t);
    if (c) {
        const i = Mu(o, e.$);
        l && i?.wn?.(t, s, n, r);
        Iu(s, i);
    }
}

function On(t, n, e, s) {
    e[t] = n;
    const o = jn(e, t, s.ft);
    o && xu(s.$, s, o);
}

function jn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(as);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Qu = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Hu = '"';

const Ju = "[";

const Yu = "]";

const Gu = ",";

const Zu = Symbol();

const Ku = [ void 0, null, !0, !1, "", Gi, Zi, ls, as, Yi, uo, oo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const tc = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const nc = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n._t;
    let o = n.gt;
    const r = ri();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => sr(t) && t._t == ir)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.ot));
        if (!o) {
            throw er(14, [ n._t ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Fn(t, n, e, s) {
    return Sa(t, n, null, null, e, s);
}

function Xn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Fn(o, r, i, n);
}

class ec {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class rc {
    Yn;
    Gn=0;
    Pt=[];
    Zn=0;
    Kn=new Set;
    te=new Map;
    ne;
    ee=new Map;
    re=0;
    ie=new WeakSet;
    Jt;
    se=typeof Temporal !== "undefined";
    constructor(t) {
        this.Yn = t;
        this.Jt = t.Jt;
    }
    async serialize() {
        const t = this.re;
        this.re = 0;
        this.ie = new WeakSet;
        try {
            await this.outputRoots();
        } finally {
            this.re = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.re;
        this.re = s;
        this.ie = new WeakSet;
        this.Jt.write(Ju);
        this.Yn.oe = 0;
        try {
            this.Jt.write(t + "");
            this.Jt.write(Gu);
            this.Jt.write(Ju);
            await this.outputSelectedRoots(n);
            this.Jt.write(Yu);
            const s = this.getForwardRefsPayload();
            this.Yn.oe = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Jt.write(Gu);
                s ? this.outputForwardRefsArray(s) : this.Jt.write("0");
            }
            if (e !== void 0) {
                this.Jt.write(Gu);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Jt.write(Hu);
                    this.writeRootRefPath(e);
                    this.Jt.write(Hu);
                }
            }
        } finally {
            this.re = o;
        }
        this.Jt.write(Yu);
    }
    le(t) {
        this.Jt = t;
    }
    outputArray(t, n, e) {
        this.Jt.write(Ju);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Jt.write(Gu) : s = !0;
            e(t[n], n);
        }
        this.Jt.write(Yu);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Hu + t + Hu;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Jt.write(n.slice(s, e));
            this.Jt.write("<\\/");
            s = e + 2;
        }
        this.Jt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Jt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Jt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Jt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Jt.write(Hu);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Jt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Jt.write(Hu);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Jt.write(t + Gu);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Jt.write(Hu);
                this.writeRootRefPath(n);
                this.Jt.write(Hu);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Jt.write(t + Gu);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Jt.write(t + Gu + n);
        } else if (typeof n === "string") {
            this.Jt.write(t + Gu);
            this.outputString(n);
        } else {
            this.Jt.write(t + Gu);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Yn.getSeenRef(t);
        const o = !e && this.te.get(t);
        if (s) {
            s.ne && this.isSeenInStreamedRoot(s) && (s = this.Yn.ue(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Yn.ce(t, this.ne, n);
            }
            s = this.Yn.kt(t, !0);
        }
        if (s.ne) {
            if (this.ne) {
                this.Yn.fe(s, t);
            } else {
                this.Yn.fe(s, t, n);
                t = this.Yn.ae[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Ft;
            this.te.delete(t);
        }
        const r = t instanceof dc ? t.he : s.Ft;
        if (!this.ne && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ne; ) {
            t = t.ne;
        }
        return t.Ft < this.re;
    }
    writeValue(t, n) {
        if (wf(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === ls) {
                    this.output(3, 7);
                } else if (t === as) {
                    this.output(3, 8);
                } else if (t === Yi) {
                    this.output(3, 9);
                } else {
                    if (t !== Zu) {
                        throw er(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === uo) {
                    this.output(3, 10);
                } else if (t === oo) {
                    this.output(3, 11);
                } else if (sr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Yn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Yn.kt(n);
                            const i = this.Yn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.ee.get(l);
                            if (u) {
                                const t = this.Yn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ee.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!La(t)) {
                        throw er(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[ja];
                        this.Yn.de.add(n._t);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Gi) {
                    this.output(3, 5);
                } else if (t === Zi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof dc) {
                    this.output(1, t.he);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ne;
                        this.ne = e;
                        this.writeObjectValue(t);
                        this.ne = n;
                    }
                }
                break;

              default:
                throw er(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (os(t)) {
            const n = t[Qi];
            this.output(38, [ ac(n), n.varProps, n.constProps, t[Hi].ft ]);
        } else if (t instanceof js) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof us) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof ec) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (zu(t)) {
            const n = Fu(t);
            const e = Xu(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Yn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Nu(t)) {
            const n = t[bf](t);
            if (fi(n)) {
                const t = this.resolvePromise(n, (t, n) => new ic(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ne.Ft;
                this.ne = this.ne.ne;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        wf(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Yn.pe(t)) {
            this.Yn.$e(t.ye, 16);
            this.output(11, t.ye.id);
        } else if (t instanceof ds) {
            if (t instanceof _s) {
                const n = function e(t, n) {
                    if (n === ls) {
                        return n;
                    }
                    return hi(t.Dt.resolved || t.Dt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && bf in n && (e = n[bf](n));
                        e === void 0 && (e = ls);
                        return e;
                    });
                }(t, t.Xt);
                if (fi(n)) {
                    const e = this.resolvePromise(n, (n, e) => new ic(34, n, e, t.ft, t.Dt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Dt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Os) {
                this.output(31, [ ...Dn(this.Yn, t), t.h, t._, ...t.ft || [] ]);
            } else if (t instanceof $s) {
                let n = t.Xt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = wf(t.Xt);
                const i = !!(t.h & 512);
                const c = i && !!t.Wt;
                const l = i && t.zt !== 1 ? t.zt : void 0;
                const u = i && t.Bt !== 0 ? t.Bt : void 0;
                o || r || c ? n = ls : e ? n = t.Xt : s && (n = ls);
                const f = n === ls && t.Xt !== ls;
                const a = i && t.h & -25 | (f ? 128 : 0) || void 0;
                const h = [ t.Dt, t.ft ];
                if (i) {
                    const n = t.Wt;
                    h.push(t.yt, t.wt, n === void 0 ? n : qf(n));
                    h.push(a || void 0);
                }
                n === ls && l === void 0 && u === void 0 || h.push(n === void 0 ? Zu : n);
                if (i) {
                    h.push(l);
                    h.push(u);
                }
                this.output(i ? 33 : 32, h);
            } else {
                const n = t.Xt;
                const e = [ n === void 0 ? Zu : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Yn.we(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Yn.kt(t);
            this.Yn.me(t, jr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                if (!this.ie.has(e)) {
                    this.ie.add(e);
                    sc(e, this.Yn);
                }
                this.Yn.$e(t, 16, !0);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Yn.$e(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Ds(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof ku) {
            const n = [ t.bt, t.h, t.Ft, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (fi(t)) {
            const n = this.resolvePromise(t, (t, n) => new ic(24, t, n));
            this.output(2, n);
        } else if (t instanceof ic) {
            if (t.ve === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.be ]);
                } else {
                    if (!t._e) {
                        console.error(t.be);
                        throw er(33);
                    }
                    {
                        const n = this.ne.Ft;
                        this.ne = this.ne.ne;
                        this.writeValue(t.be, n);
                    }
                }
            } else {
                this.output(24, [ t._e, t.be ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof fc) {
            const n = t.ge;
            if (this.getSeenRefOrOutput(n, this.ne.Ft, !0)) {
                let t = this.te.get(n);
                if (t === void 0) {
                    t = this.Zn++;
                    this.te.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.se && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.se && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.se && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!hl(t)) {
                throw er(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Zn++;
        t.then(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!0, s));
        }).catch(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!1, s));
        });
        this.Kn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Yn.Ee + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {ae: n} = this.Yn;
        for (;this.Gn < n.length || this.Kn.size; ) {
            let e = t > 0;
            for (;this.Gn < n.length; this.Gn++) {
                e ? this.Jt.write(Gu) : e = !0;
                this.writeValue(n[this.Gn], this.Gn);
                t++;
            }
            if (this.Kn.size) {
                try {
                    await Promise.race(this.Kn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Kn.size; ) {
            if (e < t.length) {
                n ? this.Jt.write(Gu) : n = !0;
                const s = t[e++];
                this.writeValue(this.Yn.ae[s], s);
                continue;
            }
            try {
                await Promise.race(this.Kn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Jt.write(Hu);
                this.writeRootRefPath(t);
                this.Jt.write(Hu);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Jt.write(Ju);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Yn.Se = this.Yn.ae.length;
        this.Yn.ke = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Jt.write(Gu);
            this.Jt.write(14 + Gu);
            this.outputForwardRefsArray(n);
        }
        this.Jt.write(Yu);
        this.Yn.Re = this.Yn.ae.length + (this.Yn.ke ? 1 : 0);
        this.Yn.oe = e;
    }
}

class ic {
    ve;
    _e;
    be;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.ve = t;
        this._e = n;
        this.be = e;
        this.ft = s;
        this.bt = o;
    }
}

const sc = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (oc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === jr || t === Fr && (Ls(s) || lc(e, s))) {
                    continue;
                }
                n.kt(s);
            }
        }
    }
};

const oc = t => typeof t === "object" && t !== null && !Ls(t);

const lc = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, or)) {
        return !1;
    }
    const s = n[Qi];
    return Ls(s.varProps) && !uc(n) && !cc(t[_r]);
};

const uc = t => !!t[Hi].ft?.size;

const cc = t => t instanceof Map && t.has(":");

function Dn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class fc {
    ge;
    constructor(t) {
        this.ge = t;
    }
}

const ac = t => new fc(t);

let hc = () => !1;

class dc {
    he;
    constructor(t) {
        this.he = t;
    }
}

class pc {
    NodeConstructor;
    DomRefConstructor;
    St;
    me;
    $t;
    Jt;
    Pe=new Map;
    Te=new Map;
    Ae=0;
    qe=[];
    ae=[];
    Ie=[];
    Me;
    Ee=0;
    Re=0;
    oe=0;
    Se=0;
    ke=!1;
    xe=new Set;
    Lt=new Set;
    jt=new Set;
    de=new Set;
    Ne;
    $e=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.me = s;
        this.$t = o;
        this.Jt = r;
        this.Ne = new rc(this);
    }
    async Ht() {
        await this.Ne.serialize();
    }
    async Ce(t, n, e, s) {
        await this.Ne.serializePatch(t, n, e, s);
    }
    le(t) {
        this.Jt = t;
        this.Ne.le(t);
    }
    getSeenRef(t) {
        return this.Pe.get(t);
    }
    ce(t, n, e) {
        const s = {
            Ft: e,
            ne: n
        };
        this.Pe.set(t, s);
        return s;
    }
    Oe(t) {
        const n = [];
        for (;t.ne; ) {
            n.unshift(t.Ft);
            t = t.ne;
        }
        n.unshift(t.Ft);
        return n;
    }
    fe(t, n, e) {
        const s = this.Oe(t);
        const o = e === void 0;
        e === void 0 && (e = this.ae.length);
        this.ae[e] = new dc(s);
        o && (this.Ie[e] = n);
        t.ne = null;
        t.Ft = e;
        o && this.Me?.(e, this.ae[e], n);
    }
    kt(t, n = !1) {
        let e = this.Pe.get(t);
        let s;
        if (e) {
            e.ne && this.fe(e, t);
            s = e.Ft;
        } else {
            s = this.ae.length;
            e = {
                Ft: s
            };
            this.Pe.set(t, e);
            this.ae.push(t);
            this.Ie.push(t);
            this.Me?.(s, t, t);
        }
        return n ? e : s;
    }
    ue(t) {
        const n = this.ae.length;
        const e = {
            Ft: n
        };
        this.Pe.set(t, e);
        this.ae.push(t);
        this.Ie.push(t);
        this.Me?.(n, t, t);
        return e;
    }
    je(t, n) {
        const e = this.ae.length;
        const s = {
            Ft: e
        };
        this.Pe.set(n, s);
        this.ae.push(t);
        this.Ie.push(n);
        return e;
    }
    we(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    pe(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Le(t) {
        const n = this.Pe.get(t);
        return n && (n.ne ? void 0 : n.Ft);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Te.get(t);
        if (o === void 0) {
            o = this.Ae + this.qe.length;
            this.Te.set(t, o);
            if (s) {
                this.qe.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.qe.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Fe(t, n) {
        this.Ae = t;
        if (n) {
            this.Te.clear();
            for (let t = 0; t < n.length; t++) {
                this.Te.set(n[t], t);
            }
        }
    }
}

const Ld = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Qu(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    hc = n ? t => t instanceof n : () => !1;
    return new pc(t, n, e, s, o, r);
};

const $c = (t, n) => t[n];

const yc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        zu(t) && (t = Xu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!yc(na($c, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!yc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Ru(t)) {
            return !0;
        }
        if (os(t)) {
            return !0;
        }
        if (fi(t)) {
            return !0;
        }
        if (Ds(t)) {
            return !0;
        }
        if (Nu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof js) {
            return !0;
        }
        if (hc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (sr(t) || La(t) || t === uo || t === oo) {
            return !0;
        }
    } else if (t === Yi || t === ls || t === as) {
        return !0;
    }
    return !1;
};

const wc = (t, n) => {
    let e = hl(t) ? kn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ze(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let mc = !1;

const vc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (mc = !0);
            const n = `{${Ze(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${wc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = _c(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${vc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${bc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = mc ? "" : `(${JSON.stringify(t).length} chars)`;
        mc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const bc = t => nc[t] || `Unknown(${t})`;

const _c = t => tc[t] || `Unknown(${t})`;

function Wn(t, n, e, s = 0) {
    const o = Vn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Vn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const gc = new WeakMap;

const Ec = /^[A-Za-z0-9+/]*$/;

const Sc = t => {
    const n = t.Qt === void 0;
    t.Qt ??= new Map;
    return n;
};

const kc = (t, n) => {
    if (n) {
        t.Qt.clear();
        t.Qt = void 0;
    }
};

const Rc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Gt(e);
        return s === -1 || s === void 0 ? Yi : t.k(s);

      case 14:
        return e;

      case 3:
        return Ku[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = Fn(u, f, r !== -1 ? s : null, t);
            } else {
                n = Fn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new ku(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Oa(null);

      case 30:
        return new ds(t, 0);

      case 31:
        return new Os(t, null, null, null);

      case 32:
        return new $s(t, null);

      case 33:
        return new gs(t, null, void 0, {});

      case 34:
        return new _s(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Rc(t, s, o);
            const i = Uu(r, 0, t);
            sf(s) && t.Qt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Fs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        gc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Ec.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw er(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return y(null);

      case 10:
        return zn(t, e);

      case 11:
        const l = zn(t, e);
        if (hl(l)) {
            Yl(l);
            return yu(l);
        }
        throw er(17, [ typeof l ]);

      case 39:
        return new js({});

      case 42:
        return new js({
            j: null,
            rt: !0
        });

      case 43:
        return new js({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new us(null, null, null, null);

      case 41:
        return new ec;

      default:
        throw er(18, [ n ]);
    }
};

function zn(t, n) {
    return n ? t.rootVNode ? Tl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Pc = (t, n, e) => {
    let s = null;
    let o = null;
    if (nr(t)) {
        o = t;
    } else {
        if (!tr(t)) {
            throw er(7, [ t ]);
        }
        s = t;
    }
    return Sa(s, n, null, o, e);
};

const Tc = (t, n, e) => Sa(null, n, t, null, e);

const Ac = (t, n) => Sa(null, t, null, null, n);

const qc = (t, n, e) => {
    const s = Ac(t, e);
    return s;
};

const Ic = (t, n, e, s) => Sa(t, e, null, n, s);

const Mc = (t, n, e, s, o) => {
    const r = Ic(t, n, e, o);
    r.Xe(s);
    return r;
};

const xc = (t, n, e, s) => {
    const o = Pc(t, n, s);
    return o;
};

const Nc = (t, n, e, s) => {
    const o = Tc(t, n, s);
    return o;
};

const Cc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Oc = (t, n, e) => new Os(null, t, n, e || null);

class jc {
    De;
    $t;
    pn=null;
    It=!1;
    cn;
    k;
    dn;
    We=0;
    Zt=null;
    Ve=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.dn = t;
        this.cn = n;
        this.De = rr;
        this.$t = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ia(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        if (Ve) {
            return Ld(t, n, e, this.setHostProp.bind(this), this.$t, s);
        }
        throw Error("Serialization context is only available on the server");
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Lc = Symbol();

const jd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Lc] = t;
    return n;
};

class Fc {}

class Xc {}

const Dc = t => {
    const n = t.Tt;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Wc = t => {
    t.catch(() => {});
};

function Bn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Qn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Wc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Fc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.catchBoundary && Dc(n)) {
                        continue;
                    }
                    e = "hook";
                    await t(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && c === Xc) {
                    const t = o.pop();
                    if (Dc(n)) {
                        continue;
                    }
                    const e = t.apply(n);
                    fi(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const t = o.pop();
                        if (__EXPERIMENTAL__.catchBoundary && Dc(n)) {
                            continue;
                        }
                        o.push(await t);
                    } else {
                        const t = c.apply(n);
                        fi(t) && await t;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && Dc(n)) {
                    fi(c) && c.catch(() => {});
                    continue;
                }
                Jn(n, r, i, c, s);
            } catch (t) {
                n.handleError(t, n.getOrCreateLastNode(), e);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                fi(t) && await t;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.catchBoundary && typeof n === "function" && t(Xc);
}

function Jn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (Tu(s)) {
            t.openFragment(Zi);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Os ? s.st() : s;
            n(t.closeFragment);
            n(() => ia(o, e, ".", t));
            n(Fc);
        } else if (fi(s)) {
            t.openFragment(Zi);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.catchBoundary && Dc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Qn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Qn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = es(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.catchBoundary && es(r, $r) && n(((t, n) => {
                    const e = t.Tt;
                    t.Tt = n;
                    return () => {
                        t.Tt = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.At) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (nr(i)) {
                if ((__EXPERIMENTAL__.pendingBoundary || __EXPERIMENTAL__.catchBoundary) && (t => typeof t === "function" && Lc in t)(i)) {
                    n(() => (t => t[Lc])(i)(t, r, o, n));
                    return;
                }
                if (i === oo) {
                    const e = r.key != null ? {
                        [Lr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === uo) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[ar] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[fr] = u;
                        n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(Bn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Zi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === ao) {
                    t.commentNode(es(r, "data") || "");
                } else if (i === po) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = nr(s) ? s({
                        async write(n) {
                            await Qn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    fi(i) ? e(i) : n(i);
                } else if (i === fo) {
                    t.htmlNode(es(r, "data"));
                } else if (i === ho) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (La(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[ja];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(or, o);
                        s.setProp(Fr, r);
                        n.key !== null && s.setProp(Lr, n.key);
                        return Jo(t, s, s, o, r);
                    })(t, r, i);
                    if (fi(l)) {
                        Wc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = go(s.getProp(vr));
                            n(e);
                            n(Bn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = go(s.getProp(vr));
                        n(Bn(o, t, c));
                    }
                } else {
                    const s = {
                        [Lr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Jo(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    fi(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Yn(t, n, e, s) {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Zn(o);
        if (!e || !e.qt) {
            continue;
        }
        if (t.It && e.Mt) {
            throw n;
        }
        Lf(e, n, s);
        $i(t).xt = !0;
        t.It && Cf(e);
        Gn(t, o, e);
        return;
    }
    throw n;
}

function Gn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Zn(t);
            n?.error === void 0 && t.hasSlotProps() || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Kn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Nt(o);
        } else if (s?.id) {
            t.Nt(s);
            e.projectedContentOwner = s;
        }
    }
}

function Zn(t) {
    const n = t.getProp(br);
    return n ? oi(n, kf.id, 0) : null;
}

function Kn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(ar);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp(fr) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Pn(t, n);
    const r = n.getProp(Xr);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            Ru(e) && Pn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Kn(t, i[n], e, s);
        }
    }
}

const Vc = () => ma;

const zc = async t => {
    const [n, e] = ma;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Nn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Uc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e) {
        return e;
    }
    const r = Sa(null, "_rsc", zc, null, [ t, {} ], o.$);
    const i = ks(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Bc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (fi(t)) {
        return t.then(n, s);
    }
    const o = Qc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s) {
        const t = r.error ?? r.Wt;
        if (t) {
            return s(t);
        }
    }
    const i = o ? r.value?.r : r.value;
    return fi(i) ? i.then(n, s) : n(i);
};

const Qc = t => t && t.__brand === "resource";

function te(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n._t.startsWith("_") && (Array.isArray(n.Ct) || s && n.Ot) && (n = Sa(null, "_run", C, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (sr(o)) {
                i(c(o));
                ne(t, n, o);
            } else if (o != null) {
                const e = te(t, n, o, s);
                e && i(e);
            }
        }
    } else if (sr(r)) {
        o = c(r);
        ne(t, n, r);
    }
    return o;
}

function ne(t, n, e) {
    const s = Ii(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.jt.add(r);
        t.Lt.add(e);
    }
}

const Hc = (t, n, e) => {
    Gc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Jc = (t, n, e) => {
    Gc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Yc = (t, n, e) => {
    Gc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Gc = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Zc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + qi(i), e, s);
            }
        } else {
            r(t + qi(n), e, s);
        }
    }
};

const Zc = () => {
    const t = Kf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Ur);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Ur, s);
    }
    let o = t.$.getHostProp(e, Br);
    o === null && (o = 0);
    t.$.setHostProp(e, Br, o + 1);
    let r = t.$.getHostProp(e, Qr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Qr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Kc = function(t, n) {
    const e = Ie(n);
    return Qf(e, () => {
        typeof this === "string" && va(ba(e, this));
        const s = ma?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = ma?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        mn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let tf;

function ee(t) {
    const n = Gf();
    if (!n) {
        return;
    }
    tf ||= Tc(Kc, "_hmr");
    const e = n._;
    const s = tf.w([ e, t ]);
    Jc("qHmr", s);
}

function re(t, n, e, s, o) {
    const r = al();
    bl(r, fr, o);
    r.parent = n;
    bl(n, o, r);
    bl(r, or, e);
    bl(r, Fr, s);
    r.dirty = 4;
    pn(t, r, 1);
    return r;
}

function ie(t, n) {
    bl(t, ur, n);
    t.flags |= 2048;
}

function se(t, n, e) {
    bl(n, Fr, e);
    mn(t, n, 4);
}

function oe(t, n, e, s) {
    bl(n, s, null);
    const o = [];
    kt(t, o, e);
    Nl(o);
    if (e.flags & 2048) {
        const t = vl(e, ur, null);
        t && t.replaceChildren();
        bl(e, ur, null);
        e.flags &= -2049;
    }
}

let nf = Promise.resolve();

const ef = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const rf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !ef.has(t));
};

function* le(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ce(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ue(t, n, e = Array(n.length / 2)) {
    const s = Sc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : Rc(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            sf(r) && (yield* fe(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        kc(t, s);
    }
    return e;
}

function* ce(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Rc(t, n, e);
    sf(n) && (yield* fe(t, s, n, e));
    return s;
}

function* fe(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* le(t, s));
    switch (e) {
      case 4:
        yield* le(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!rf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = gc.get(t);
            if (e) {
                if (gc.has(o)) {
                    throw er(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                rf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.bt = e[0];
            t.h = e[1];
            t.Ft = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[ja][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Xt = e[0];
            t.ft = new Set(e.slice(1));
            he(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Xt = ls;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && hl(t._)) {
                    const n = t._;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (tr(e)) {
                                const o = vl(n, e, null);
                                if (o !== null) {
                                    t.Xt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Jl(n);
                        e && n.firstChild === n.lastChild && yl(e) && (t.Xt = Ql(e));
                    }
                }
            })(e);
            he(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.Wt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Vt = !0);
            const o = e.length > 6;
            o && (t.Xt = e[6]);
            t.Xt === ls && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.zt = e[7] ?? 1;
                t.Ut = [];
            }
            t.Bt = e[8] ?? 0;
            he(t.ft, t);
            he(t.yt, t);
            he(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Dt = r[0];
            const i = o.Dt.resolve(t).catch(() => {});
            nf = nf.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Xt = r[2]);
            e !== 34 && o.Xt !== ls && (o.h &= -2);
            he(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === Yi) {
                o = new Fs(oo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[Qi] = o;
            const r = t[Hi];
            r.ft = e[3];
            de(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            ae(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            ae(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Vu(n);
            const o = t.Qt.get(e);
            if (o) {
                t.Qt.delete(e);
                yield* fe(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Fu(n);
            c.h = r;
            c.ft = i;
            de(c.ft, e);
            break;
        }

      default:
        throw er(16, [ e ]);
    }
}

function ae(t) {
    const n = Ve;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[yi] ||= new Map;
    e[yi].set(t.property, t);
}

function he(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function de(t, n) {
    if (t) {
        for (const [, e] of t) {
            he(e, n);
        }
    }
}

const sf = t => t >= 23 || t === 4 || t === 5;

const of = new WeakMap;

const lf = Symbol();

const uf = (t, n) => {
    if (!Array.isArray(n) || hl(n) || (t => Ze(t) && lf in t)(n)) {
        return n;
    }
    let e = of.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new cf(t, n));
        of.set(n, e);
    }
    return e;
};

class cf {
    $;
    ze;
    constructor(t, n) {
        this.$ = t;
        this.ze = n;
    }
    get(t, n, e) {
        if (n === lf) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ze.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ze[o];
        const i = this.ze[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Sc(c);
        try {
            const e = Rc(c, r, i);
            Reflect.set(t, n, e);
            this.ze[o] = 0;
            this.ze[o + 1] = e;
            sf(r) && ((t, n, e, s) => {
                const o = Sc(t);
                try {
                    const o = fe(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    kc(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            kc(c, l);
        }
    }
    has(t, n) {
        if (n === lf) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === lf) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ze.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ze[i] = 0;
        this.ze[i + 1] = e;
        return !0;
    }
}

const ff = t => {
    if (!t.Ue) {
        t.Ue = !0;
        t.Be();
    }
};

const af = (t, n, e) => {
    const s = {
        Qe: t,
        Be: void 0,
        Ue: !1
    };
    const o = tl(() => {
        ((t, n, e) => {
            t.Ue = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Qe.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        ff(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.zn?.();
            n(t);
        }, t => {
            o.zn?.();
            e(t);
        });
    });
    s.Be = o;
    return s;
};

async function pe(t) {
    const n = Ld(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Ht();
    return n.Jt.toString();
}

async function $e(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = me(n, () => e);
    s.Yt = e;
    await hf(ue(s, n, e));
    return e[0];
}

const hf = t => new Promise((n, e) => {
    const s = af(t, n, e);
    ff(s);
});

function ye(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function we(t) {
    let n;
    const e = me(t, () => n);
    n = uf(e, t);
    e.Yt = n;
    return e;
}

function me(t, n) {
    const e = {
        k: t => ye(t, n()),
        Gt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Wn(t, e);
    return e;
}

const df = (t, n) => {
    const e = new WeakSet;
    return na(pf, t, e, "_", n);
};

const pf = (t, n, e, s) => {
    const o = Vu(t);
    if (o == null) {
        return t;
    }
    if (yf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Tu(o)) {
            return t;
        }
        if (yc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (fi(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ke(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw er(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw er(3, [ o ]);
                    }
                    pf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Mi) {
                return t;
            }
            if (Ge(o)) {
                for (const [t, s] of Object.entries(o)) {
                    pf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw er(3, [ i ]);
    }
    return t;
};

const $f = /*#__PURE__*/ new WeakSet;

const yf = t => {
    if (Ze(t) || nr(t)) {
        return !$f.has(t) && !(vf in t);
    }
    return !0;
};

const wf = t => !!t && (Ze(t) || typeof t === "function") && ($f.has(t) || vf in t);

const mf = t => {
    (Ze(t) && t !== null || typeof t === "function") && $f.add(t);
    return t;
};

const vf = Symbol();

const bf = Symbol();

const _f = t => /*#__PURE__*/ Object.freeze({
    id: qi(t)
});

const gf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const Ef = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(je(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw er(8, [ t.id ]);
};

const Sf = t => {
    const n = Zf();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const kf = /*#__PURE__*/ _f("qk-error");

const Rf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const Pf = "An error occurred";

const Tf = t => So(Rf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const Af = /*#__PURE__*/ Symbol();

const qf = t => {
    const n = Error(Pf);
    n.digest = Tf(t);
    Object.defineProperty(n, Af, {
        value: !0
    });
    return n;
};

const If = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = Pf;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Mf = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => Rf(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : qf(t);
            }
            if (s != null) {
                n && fi(s);
                return qf(t);
            }
        }
        if (Rf(() => t instanceof Error && Af in t, !1)) {
            return t;
        }
        if (!n) {
            return qf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return If(t);
    } catch {
        return qf(t);
    }
};

const xf = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = Tf(n);
        Promise.resolve(t(If(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(He);
    } catch (t) {
        He(t);
    }
};

const Nf = /*#__PURE__*/ new WeakSet;

const Cf = t => {
    Nf.add(t);
};

const Of = /*#__PURE__*/ Symbol();

const jf = (t, n) => {
    try {
        Object.defineProperty(t, Of, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Lf = (t, n, e = "render") => {
    t.error = n ?? If(n);
    const s = t.He;
    s && xf(s, n, (t => Rf(() => t?.[Of], void 0))(n) ?? e, t.boundaryId ?? "");
};

const Ff = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Ir)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        He(t);
    }
};

function ve(t, n) {
    const e = t.getHostProp(n, br);
    return e ? oi(e, kf.id, 0) : null;
}

const Fd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Xd = new WeakMap;

class Dd {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Wd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Fd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Wd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Vd = () => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return !1;
    }
    const t = Gf()?.$;
    return t?.outOfOrderStreaming === !0 && !Cd(t);
};

const Xf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && xu(t, n, r);
};

const Df = new WeakMap;

function* be(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Zt}"]${dr}`);
    const o = Wf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(pr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* _e(t, e, i.textContent);
        yield;
    }
}

const Wf = t => {
    let n = Df.get(t);
    if (!n) {
        n = new WeakSet;
        Df.set(t, n);
    }
    return n;
};

function* _e(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Kt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Kt[e * 2 + t] = s[t];
            yield;
        }
        yield* Vn(n.Kt, t, e * 2);
        n.tn = uf(t, n.Kt);
        n.tn.length = n.Kt.length / 2;
        n.nn = n.Pt;
    }(t, n, s, o);
    Vf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.pendingBoundary || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof ds) {
                r instanceof Set && Xf(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Fu(o);
                const e = Xu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    Xf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const Vf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.nn ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const zf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function ge(t, n) {
    const e = t.qVNodeDataState ||= {
        en: [],
        rn: null
    };
    t.qProcessVNodeDataPatch ||= n => ge(t, ke(t, n));
    t.qVNodeDataReady = !1;
    e.en.push(n);
    Ee(t, e);
}

function Ee(t, n) {
    if (n.rn) {
        return;
    }
    const e = n.en.shift();
    if (!e) {
        Se(t);
        return;
    }
    n.rn = af(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.rn = null;
            Ee(t, n);
        }
    }, e => {
        n.rn = null;
        He(e);
        Se(t);
    });
    ff(n.rn);
}

function Se(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* ke(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Re(t, s || void 0, e, o, n.textContent));
}

function* Re(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.pendingBoundary && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.pendingBoundary && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = t => {
        let n = null;
        for (;t && !(n = _(t)); ) {
            t = t.parentNode;
        }
        return n;
    };
    const g = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.pendingBoundary && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let E = -1;
        let k = null;
        const R = () => {
            let t = 0;
            for (;Uf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            k = null;
            const P = s == e ? 2 : b(s);
            if (P === 3) {
                const t = s;
                k = v(s);
                yield* g(n, t, s, k, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (P === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (P === 64) {
                k = s;
                let t;
                do {
                    k = n.nextNode();
                    if (!k) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(k);
                } while (t !== 32 && t !== 65);
                k = null;
            } else if (P === 9) {
                k = s;
                do {
                    k = _(k);
                    if (!k) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(k) !== 8);
                yield* g(n, s, s, k, "", null, c);
            } else if (P === 6) {
                k = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* g(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((P & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += R();
                        if (m === 126) {
                            E = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = Bf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.pendingBoundary && !u && P === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? Ei(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== gi || n.charCodeAt(1) !== gi || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        P !== 3 && d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.pendingBoundary && t !== null) {
                    yield* S(c, s, t);
                    k = _(s);
                    k && (n.currentNode = k);
                }
            }
            yield;
        } while (s = k || n.nextNode());
    };
    const E = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* g(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* E(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.pendingBoundary && n !== void 0 ? yield* S(e, s, n, o) : yield* E(e, s, o);
        return;
    }
    yield* m(t);
    const k = t.createTreeWalker(t, 129);
    yield* g(k, null, k.firstChild(), null, "", null, null);
}

const Uf = t => 33 <= t && t <= 46;

const Bf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Uf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Pe(t) {
    return t.sn === 3;
}

function Te(t, n) {
    const e = t.ln ||= {
        en: [],
        rn: null
    };
    t.sn = 2;
    e.en.push(n);
    Ae(t, e);
}

const Qf = (t, n) => {
    const e = t;
    if (Pe(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Pe(e)) {
                    (e.un ||= []).push(s);
                    return;
                }
                zf(e.document, () => {
                    Pe(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Ae(t, n) {
    if (n.rn) {
        return;
    }
    const e = n.en.shift();
    if (!e) {
        qe(t);
        return;
    }
    n.rn = af(e, () => {
        n.rn = null;
        Ae(t, n);
    }, e => {
        n.rn = null;
        He(e);
        qe(t);
    });
    ff(n.rn);
}

function qe(t) {
    const n = t.sn;
    if (n !== 2) {
        return;
    }
    t.sn = 3;
    t.ln = void 0;
    const e = t.un;
    t.un = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ie(t) {
    const n = xe(t);
    if (!n) {
        throw er(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new Hf(n);
}

function xe(t) {
    return t.closest(Ir);
}

function Ne(t, n) {
    const e = t + "";
    const s = n?.closest(Ir);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.pendingBoundary || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            ge(t, function* i(t, n, e, s, o, r) {
                yield* Re(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* ke(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        zf(t, () => {
            o.element.qContainer === o && Te(o, be(o, e));
        });
    }
}

class Hf extends jc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Je;
    Zt;
    Pt=null;
    vNodeLocate=t => Tl(this.rootVNode, t);
    sn=0;
    un=void 0;
    ln=void 0;
    Kt;
    tn;
    nn=null;
    Ye=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Tr);
        if (!this.qContainer) {
            throw er(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Ve = t.getAttribute(Er);
        this.Zt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = cl(this.element);
        this.Kt = [];
        this.tn = [];
        __EXPERIMENTAL__.pendingBoundary && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Ne);
        this.Je = gr(n, this.Zt) || Gi;
        this.Ge();
        t.qContainer = this;
        t.qDestroy = () => this.zn();
        __EXPERIMENTAL__.catchBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Ff;
                t.addEventListener?.("qerror", Ff);
            }
        }(this.document);
        this.sn = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            ge(e, function* s(t) {
                yield* Re(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        zf(n, () => {
            this.sn === 1 && Te(this, this.Ze());
        });
    }
    * Ze() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Zt}"]:not(${dr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${dr})`);
        if (n) {
            this.Kt = JSON.parse(n.textContent);
            yield* Vn(this.Kt, this);
            this.nn = this.Pt;
            const e = this.Kt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.tn = s !== null && e > 0 && e >= +s ? yield* ue(this, this.Kt) : uf(this, this.Kt);
        }
        __EXPERIMENTAL__.pendingBoundary && (yield* be(this));
        this.Ke();
        t.setAttribute(Tr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    zn() {
        this.vNodeLocate = () => null;
        this.Kt.length = 0;
        this.tn.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.pendingBoundary && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Tr);
        const n = t.ownerDocument;
        this.ln = void 0;
        this.sn = 0;
        const e = n.querySelector(Ir) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.pendingBoundary && (e || (n.qProcessOOOS = void 0));
    }
    Ke() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(mr);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Qn(t, n) {
        this.tn[t] = n;
    }
    parseQRL(t) {
        return Xn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.catchBoundary) {
            const e = n && this.resolveContext(n, kf);
            if (!e) {
                Je(t);
                return;
            }
            e.error = t;
            return;
        }
        const s = t ?? If(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, kf);
            if (!n) {
                break;
            }
            const r = ve(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Fr);
                xf(o?.onError$, t, e, r.boundaryId ?? "");
                mn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                He(t);
                return;
            }
            o = this.getParentHost(n);
        }
        Je(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, br);
        s == null && this.setHostProp(t, br, s = []);
        si(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? oi(this.getHostProp(e, br), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, br);
            if (e != null && li(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (wl(n)) {
                if (vl(n, or, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        bl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Xr:
          case Fr:
          case or:
          case br:
          case _r:
            s = this.k;
            break;

          case Dr:
          case Br:
            s = parseInt;
            break;
        }
        return vl(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => ye(t, this.tn);
    Gt(t) {
        return this.nn?.[t];
    }
    getSyncFn(t) {
        const n = this.Je[t];
        return n;
    }
    tr(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, vr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, vr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ye == null) {
            this.Ye = new Set;
            const t = this.document.querySelectorAll(wr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ye.add(e.getAttribute(yr));
            }
        }
        if (!this.Ye.has(n)) {
            this.Ye.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(yr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ge() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Yr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.dn = {
            containerAttributes: t
        };
    }
}

let Jf;

let zd;

if (Ve) {
    const t = Be();
    t && (zd = new t);
}

function Ce(t) {
    if (zd) {
        const t = zd.getStore();
        if (t) {
            return t;
        }
    }
    if (Jf === void 0) {
        const n = Gf();
        if (n && n.cn) {
            return n.cn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Jf;
}

function Oe(t, n) {
    if (zd) {
        return zd.run(t, n);
    }
    const e = Jf;
    const s = () => {
        Jf = e;
    };
    Jf = t;
    return ai(n, t => {
        s();
        return t;
    }, t => {
        s();
        throw t;
    });
}

let Yf;

const Gf = () => Yf;

const Zf = () => {
    const t = Gf();
    if (!t) {
        throw er(9);
    }
    return t;
};

const Kf = () => {
    const t = Gf();
    if (!t || t.fn !== Cr) {
        throw er(10);
    }
    return t;
};

function je(t, n, ...e) {
    return Le.call(this, t, n, e);
}

function Le(t, n, e) {
    const s = Yf;
    try {
        Yf = t;
        return n.apply(this, e);
    } finally {
        Yf = s;
    }
}

const ta = (t, n, e = Ie(n)) => {
    const s = Tl(e.rootVNode, n);
    const o = e.cn;
    o && function r(t) {
        if (zd) {
            zd.enterWith(t);
            return;
        }
        Jf = t;
    }(o);
    const i = Xe(o, s, t);
    i.$ = e;
    return i;
};

function Fe(t, n, e) {
    const s = {
        _: n,
        fn: Cr,
        an: void 0,
        cn: t,
        $: e,
        hn: void 0
    };
    return s;
}

function Xe(t, n, e) {
    const s = {
        _: n,
        fn: e,
        an: void 0,
        cn: t,
        $: void 0
    };
    return s;
}

const na = (t, ...n) => {
    if (typeof t === "function") {
        if (!Yf) {
            return t(...n);
        }
        {
            const e = Yf.an;
            try {
                Yf.an = void 0;
                return t(...n);
            } finally {
                Yf.an = e;
            }
        }
    }
    if (Tu(t)) {
        return t.untrackedValue;
    }
    return Vu(t);
};

const ea = /*#__PURE__*/ Fe(void 0, void 0, void 0);

const ra = (t, n, e, s, o) => {
    const r = ea.an;
    const i = ea.$;
    try {
        ea.an = w(n, e, o);
        ea.$ = s;
        return Le(ea, t);
    } finally {
        ea.an = r;
        ea.$ = i;
    }
};

const ia = (t, n, e, s, o) => {
    t instanceof Os && t._ !== n && n && (t._ = n);
    return ra(() => t.value, n, e, s, o);
};

const sa = () => Gf()?._;

const oa = () => {
    const t = Gf();
    if (t) {
        return t.fn;
    }
};

const la = () => {
    const t = Gf();
    if (t) {
        return t.$;
    }
};

const ua = t => t;

const ca = t => t.l || Promise.resolve();

let fa;

class aa {
    gt;
    _t;
    nr;
    er;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this._t = n;
        this.nr = e;
        this.er = s;
        s && this.rr(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ze && t && We(t, .8);
    }
    get ot() {
        return Md(this._t);
    }
    rr(t) {
        this.er = t;
        fi(t) && t.then(t => this.er = t, t => {
            const n = `qrl ${this._t} failed to load`;
            if (Ve) {
                console.error(n, t);
            } else if (ze) {
                const e = this.gt === null ? "symbol:" + this._t : "chunk:" + this.gt;
                const s = this.$;
                let o = s && fa?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (fa ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.er = null;
        });
    }
    ir() {
        if (this.er != null) {
            return this.er;
        }
        if (this.gt === "") {
            const t = this.$.Zt;
            const n = this.$.element?.ownerDocument || document;
            const e = gr(n, t);
            return this.er = e[+this._t];
        }
        ze && this.gt && We(this.gt, 1);
        const t = this._t;
        const n = this.nr ? this.nr().then(n => n[t]) : ri().importSymbol(this.$?.element, this.gt, t);
        this.rr(n);
        return this.er;
    }
}

const ha = Symbol();

const da = t => t?.[ha] ?? t;

class pa {
    sr;
    resolved=void 0;
    Ct;
    $;
    constructor(t, n, e) {
        this.sr = t;
        if (n) {
            this.Ct = n;
            typeof n === "string" && (this.$ = e);
        }
        t.er == null || this.Ct && typeof this.Ct === "string" || fi(t.er) || (this.resolved = ga(this, t.er));
    }
}

const $a = function(t, ...n) {
    const e = da(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Gf();
    return ya.call(e, s?.$).then(() => Le.call(t, s, e.resolved, n));
};

const ya = async function(t) {
    const n = da(this);
    return hi(Ea(n, t), () => n.resolved);
};

const wa = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[ha].resolved;
        },
        set(t) {
            this[ha].resolved = t;
        }
    },
    Ct: {
        get() {
            return this[ha].Ct;
        },
        set(t) {
            this[ha].Ct = t;
        }
    },
    Ot: {
        get() {
            return this[ha].sr.Ot;
        }
    },
    $: {
        get() {
            return this[ha].$;
        },
        set(t) {
            this[ha].$ = t;
        }
    },
    sr: {
        get() {
            return this[ha].sr;
        }
    },
    gt: {
        get() {
            return this[ha].sr.gt;
        }
    },
    _t: {
        get() {
            return this[ha].sr._t;
        }
    },
    ot: {
        get() {
            return this[ha].sr.ot;
        }
    },
    dev: {
        get() {
            return this[ha].sr.dev;
        }
    },
    lr: {
        value: $a
    },
    w: {
        value: function(t) {
            const n = da(this);
            const e = new pa(n.sr, t, n.Ct ? n.$ : void 0);
            return ka(e);
        }
    },
    m: {
        value: function() {
            this[ha].sr.Ot = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = da(this);
            n.sr.rr(t);
            n.resolved = ga(n, t);
        }
    },
    resolve: {
        value: ya
    },
    getSymbol: {
        value: function() {
            return da(this).sr._t;
        }
    },
    getHash: {
        value: function() {
            return da(this).sr.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = da(this);
            _a(t);
            return t.Ct;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = da(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ya.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Le(t, e.resolved, o);
            };
            return s;
        }
    }
});

let ma = null;

const va = t => {
    ma = t;
};

const ba = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const _a = t => {
    const n = t.Ct;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw er(13);
        }
        const s = nf;
        ma = t.Ct = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return ba(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return ba(t, n, s + 1, o);
        })(e, n);
        if (nf !== s) {
            return nf;
        }
    } else {
        ma = n || null;
    }
};

const ga = (t, n) => {
    if (typeof n !== "function" || !t.Ct) {
        return n;
    }
    return function e(...s) {
        _a(t);
        return n.apply(this, s);
    };
};

const Ea = (t, n) => {
    const e = t.sr;
    const s = typeof t.Ct === "string";
    s && !t.$ && (t.$ = n || Gf()?.$);
    if (t.resolved) {
        return;
    }
    const o = Aa();
    const r = Gf();
    const i = e.ir();
    const c = hi(i, n => {
        t.resolved = ga(t, n);
    });
    if (c) {
        const t = e._t;
        Pa(t, r?._ instanceof Ni ? r?._.node : void 0, o);
    }
    const l = s && t.$ && _a(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Sa = (t, n, e, s, o, r) => {
    const i = ((t, n, e, s, o) => new aa(t, n, e, s, o))(t, n, s, e, r);
    const c = new pa(i, o, r);
    return ka(c);
};

const ka = t => {
    const n = async function(...t) {
        return $a.call(n, this, ...t);
    };
    n[ha] = t;
    Object.setPrototypeOf(n, wa);
    return n;
};

const Ra = /*#__PURE__*/ new Set;

const Pa = (t, n, e) => {
    if (!Ra.has(t)) {
        Ra.add(t);
        Ta("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Ta = (t, n) => {
    xd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Aa = () => {
    if (xd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let qa = 0;

const Ia = t => Sa(null, "s" + qa++, t, null, null);

const Ma = Ia;

const xa = t => t;

const Na = t => Sa("", ir, t, null, null);

const Ca = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Sa("", ir, t, null, null);
};

const Oa = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[ja] = [ t ];
        return Zs(i, n, null, n.children, s, r);
    }
    n[ja] = [ t ];
    return n;
};

const ja = Symbol();

const La = t => typeof t == "function" && t[ja] !== void 0;

const Fa = t => Oa(Ma(t));

const Xa = bs(xa);

const Da = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Wa = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !ui(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Tr, "resumed");
    const s = Ie(t);
    s.dn = e.serverData || {};
    const o = s.rootVNode;
    bl(o, Xi, n);
    mn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const Va = (t, n) => {
    const {val: e, set: s, iCtx: o} = Xo();
    if (e != null) {
        return e;
    }
    const r = nr(t) ? je(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Uu(r, i, t);
        s(c);
        return c;
    }
};

const za = t => {
    const n = $i(t);
    return (t => t.toString(36))(n.We++);
};

const Ua = () => {
    const {val: t, set: n, iCtx: e} = Xo();
    if (t != null) {
        return t;
    }
    const s = e.$.Ve || "";
    const o = s ? So(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, or);
    const i = r?.getHash().substring(0, 3) || "";
    const c = za(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function De(t, n) {
    const e = Gf();
    return e?.$?.dn[t] ?? n;
}

const Ba = /*#__PURE__*/ new Map;

const Qa = (t, n) => {
    let e = Ba.get(n);
    e || Ba.set(n, e = Ha(t, n));
    return e;
};

const Ha = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Ka;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Nh) {
            r++;
            e = qh;
        }
        const s = Wh[c];
        for (let p = 0; p < s.length; p++) {
            const $ = s[p];
            const [y, w, m] = $;
            if ((y === l || y === ch || y === fh && Ja(l) || y === hh && Za(l)) && (w === e || w === ch || w === fh && Ja(e) || w === ah && !Ja(e) && e !== Sh || w === hh && Za(e))) {
                const s = r;
                if ($.length == 3 || a($)) {
                    if (c === oh && m === nh && !h()) {
                        r = s;
                        continue;
                    }
                    $.length > 3 && (e = t.charCodeAt(r - 1));
                    if (m === lh || m == uh) {
                        if (m === uh) {
                            if (c !== th || d()) {
                                if (!Ya(e)) {
                                    const t = w == ah ? 1 : w == _h ? 2 : 0;
                                    f(r - t);
                                }
                            } else {
                                Ya(e) ? u(r - 2) : f(r - 2);
                                i++;
                            }
                        }
                        if (w === ah) {
                            r--;
                            e = l;
                        }
                        do {
                            c = o.pop() || Ka;
                            if (c === nh) {
                                u(r - 1);
                                i++;
                            }
                        } while (Ga(c));
                    } else {
                        o.push(c);
                        if (c === nh && m === Ka) {
                            u(r - 8);
                            i = r;
                        } else {
                            m === eh && f(n);
                        }
                        c = m;
                    }
                    break;
                }
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === nh || d()) {
            return;
        }
        u(t);
        s.push(".", cr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Eh) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Eh) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Oh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        let n = r;
        let s = 0;
        let o = 0;
        let i = 0;
        for (;n < e; ) {
            const e = t.charCodeAt(n++);
            if (i) {
                e === Nh ? n++ : e === i && (i = 0);
            } else if (e === vh || e === wh) {
                i = e;
            } else if (e === kh && t.charCodeAt(n) === gh) {
                n = t.indexOf("*/", n + 1);
                if (n === -1) {
                    return !1;
                }
                n += 2;
            } else if (e === bh) {
                s++;
            } else if (e === _h) {
                s--;
            } else if (e === Mh) {
                o++;
            } else if (e === xh) {
                o--;
            } else if (s === 0 && o === 0) {
                if (e === Fh) {
                    return !0;
                }
                if (e === Ah || e === Xh) {
                    return !1;
                }
            }
        }
        return !1;
    }
    function d() {
        return o.indexOf(nh) !== -1 || o.indexOf(rh) !== -1;
    }
};

const Ja = t => t >= Rh && t <= Ph || t >= qh && t <= Ih || t >= jh && t <= Lh || t >= 128 || t === Ch || t === Eh;

const Ya = t => t === Th || t === Sh || t === Mh || t === mh || Ja(t);

const Ga = t => t === ih || t === rh || t === sh || t === nh;

const Za = t => t === yh || t === dh || t === ph || t === $h;

const Ka = 0;

const th = 2;

const nh = 5;

const eh = 6;

const rh = 10;

const ih = 11;

const sh = 12;

const oh = 13;

const lh = 17;

const uh = 18;

const ch = 0;

const fh = 1;

const ah = 2;

const hh = 3;

const dh = 9;

const ph = 10;

const $h = 13;

const yh = 32;

const wh = 34;

const mh = 35;

const vh = 39;

const bh = 40;

const _h = 41;

const gh = 42;

const Eh = 45;

const Sh = 46;

const kh = 47;

const Rh = 48;

const Ph = 57;

const Th = 58;

const Ah = 59;

const qh = 65;

const Ih = 90;

const Mh = 91;

const xh = 93;

const Nh = 92;

const Ch = 95;

const Oh = 32;

const jh = 97;

const Lh = 122;

const Fh = 123;

const Xh = 125;

const Dh = /*@__PURE__*/ (() => [ [ ch, vh, 14 ], [ ch, wh, 15 ], [ ch, kh, 16, "*" ] ])();

const Wh = /*@__PURE__*/ (() => [ [ [ ch, gh, th ], [ ch, Mh, 7 ], [ ch, Th, eh, ":", "before", "after", "first-letter", "first-line" ], [ ch, Th, nh, "global" ], [ ch, Th, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ ch, Th, 4 ], [ ch, fh, 1 ], [ ch, Sh, 1 ], [ ch, mh, 1 ], [ ch, 64, rh, "keyframe" ], [ ch, 64, ih, "media", "supports", "container" ], [ ch, 64, sh ], [ ch, Fh, oh ], [ kh, gh, 16 ], [ ch, Ah, lh ], [ ch, Xh, lh ], [ ch, _h, lh ], ...Dh ], [ [ ch, ah, uh ] ], [ [ ch, ah, uh ] ], [ [ ch, bh, Ka ], [ ch, ah, uh ] ], [ [ ch, bh, 8 ], [ ch, ah, uh ] ], [ [ ch, bh, Ka ], [ ch, ah, lh ] ], [ [ ch, ah, lh ] ], [ [ ch, xh, uh ], [ ch, vh, 14 ], [ ch, wh, 15 ] ], [ [ ch, _h, lh ], ...Dh ], [ [ ch, Xh, lh ], ...Dh ], [ [ ch, Xh, lh ], [ hh, fh, 1 ], [ ch, Th, nh, "global" ], [ ch, Fh, oh ], ...Dh ], [ [ ch, Fh, Ka ], [ ch, Ah, lh ], ...Dh ], [ [ ch, Ah, lh ], [ ch, Fh, 9 ], ...Dh ], [ [ ch, Xh, lh ], [ ch, Fh, oh ], [ ch, Th, nh, "global" ], [ ch, bh, 8 ], ...Dh ], [ [ ch, vh, lh ] ], [ [ ch, wh, lh ] ], [ [ gh, kh, lh ] ] ])();

const Vh = t => ({
    styleId: Qh(t, t => t, !1)
});

const zh = /*#__PURE__*/ bs(Vh);

const Uh = t => ({
    scopeId: cr + Qh(t, Qa, !0)
});

const Bh = /*#__PURE__*/ bs(Uh);

const Qh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = Xo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${So(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.tr(n(t, c), c, l, e));
    }
    r.$.tr(n(t.resolved, c), c, l, e);
    return c;
};

const Hh = (t, n) => {
    t.resolve();
    return Ss(t, n);
};

const Jh = (t, n) => Vo(Hh, t, n);

const Yh = bs(Jh);

const Gh = t => {
    t.resolve();
    return Rs(t);
};

const Zh = t => Vo(Gh, t);

const Kh = bs(Zh);

const td = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = Xo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !xd()) {
            e.h |= 32;
            nd(e, i);
        }
        return;
    }
    let c;
    if (xd() || i === "intersection-observer") {
        c = 1;
        xd() || t.resolve();
    } else {
        c = 5;
        t.resolve();
        mn(r.$, r._, 1);
    }
    const l = new ku(c, o, r._, t, null);
    s(l);
    nd(l, i);
};

const nd = (t, n) => {
    n === "intersection-observer" ? Hc("qvisible", ed(t)) : n === "document-ready" ? Jc("qinit", ed(t)) : n === "document-idle" && Jc("qidle", ed(t));
};

const ed = t => Sa(null, "_task", Mn, null, [ t ]);

const rd = bs(Uc);

const id = /*#__PURE__*/ bs(Eu);

const sd = /*#__PURE__*/ bs(td);

const od = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Ud(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${pr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.catchBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const ld = () => {
    const [t] = ma;
    const n = Gf()?.$;
    const e = ze;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, kf);
        if (!e) {
            return;
        }
        const s = ve(t, e);
        if (!s) {
            return;
        }
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = $u(n);
            let i = !1;
            for (;r; ) {
                if (wl(r)) {
                    if (vl(r, fr, null) !== null) {
                        i = !0;
                    } else if (vl(r, or, null) !== null) {
                        if (!i) {
                            const n = ve(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = $u(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${ud}`;
                mn(t, o, 4);
            } else {
                mn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const ud = "\0";

const cd = t => {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw Error('<Catch> requires the `catchBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["catchBoundary"] }).');
    }
    const n = (() => {
        const t = Va(od);
        gf(kf, t);
        return t;
    })();
    const e = Gf();
    const s = e?.$;
    s && (Xu(n) ?? n).boundaryId === void 0 && (n.boundaryId = za(s));
    const o = !ze;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ Gs(uo, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Tc(ld, "_caR", [ e?._ ]);
    if (o) {
        const e = t.fallback$;
        n.qt = mf(t => e(t, r));
        const o = t.onError$;
        o && (n.He = mf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ Gs("div", {
                [$r]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ Gs(uo, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ Gs(Hd, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Mf(n.error, !0);
    return /* @__PURE__ */ Gs(oo, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ Gs("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const fd = /*#__PURE__*/ Oa(
/*#__PURE__*/ Tc(cd, "_caC"));

const Bd = (t, n) => {
    const e = n.qt;
    delete n.qt;
    const s = Mf(n.error, Ue, t.A);
    return e(s);
};

const Qd = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ jd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.qt) {
                return;
            }
            r.error !== n && Lf(r, n, "render");
            const s = await t.segment("" + o, Bd(t, r), e);
            s.container.I(o);
            await t.C(() => Ud(t, o, s, null));
        };
        r.Mt = mf(n);
        t.write(`<template ${pr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.qt) {
        return;
    }
    Cd(t) ? t.I(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(Bd(t, r));
}) : null;

const Hd = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ jd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.pendingBoundary && t.outOfOrderStreaming && !Cd(t) && (r.error === void 0 || (t => Nf.has(t))(r));
    s(
    /*#__PURE__*/ Gs("div", {
        [i ? Nd : "q:cf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ Gs(Qd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const ad = async ({track: t}) => {
    const n = ma[0];
    t(() => n.items);
    const e = Gf();
    const s = e._;
    const o = e.$;
    const r = mn(o, s, 256);
    const i = Ve;
    i && await r;
};

const hd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ Tc(ad, "_eaT", [ t ]));
    return co;
};

const dd = /*#__PURE__*/ Oa(
/*#__PURE__*/ Tc(hd, "_eaC"));

const pd = (t, n, e) => sr(t) ? t.getFn(n)(e) : t(e);

const $d = ({track: t}) => {
    const n = ma[0];
    const e = Gf();
    const s = e._;
    const o = e.$;
    const r = Ve;
    return hi(t(() => pd(n.when$, Gf(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return hi(i ? pd(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Bt(s, n);
            mn(o, s, 2);
        });
    });
};

const yd = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Eu(/*#__PURE__*/ Tc($d, "_shT", [ t ]));
    return co;
};

const wd = /*#__PURE__*/ Oa(
/*#__PURE__*/ Tc(yd, "_shC"));

const md = /*#__PURE__*/ _f("qk-reveal");

const vd = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Ps(0)
});

const bd = () => {
    const t = ma[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ze) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Fd(t);
};

const _d = ({cleanup: t}) => {
    const n = ma[0];
    t(() => {
        if (!ze) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const gd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Vo(vd, t);
    gf(md, n);
    const e = !ze;
    if (__EXPERIMENTAL__.pendingBoundary && e && Vd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = Gf().$;
                const s = (Xd.get(e) || 0) + 1;
                Xd.set(e, s);
                return new Dd(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = mf(e);
            return e;
        })(n);
        return /* @__PURE__ */ Gs(Jd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ Gs(uo, null, null, null, 0, "u7_0");
};

const Ed = /*#__PURE__*/ Oa(
/*#__PURE__*/ Tc(gd, "_reC"));

const Jd = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ jd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ Gs(uo, null, null, null, 0, "u7_0"));
}) : null;

const Sd = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback$ == null || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Yd = '{display:p1.value==="fallback"&&p0.fallback$!=null&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const kd = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Rd = ({track: t, cleanup: n}) => {
    const e = ma[0], s = ma[1], o = ma[2], r = ma[3];
    const i = t(e);
    const c = ze;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Pd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Pending is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Wo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.pendingBoundary) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
        }
        return Wo(0);
    })();
    const s = (t => {
        const n = Ef(md, null);
        const e = Vo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Eu(/*#__PURE__*/ Tc(_d, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Jh(
    /*#__PURE__*/ Tc(bd, "_reR", [ s ]));
    Eu(
    /*#__PURE__*/ Tc(Rd, "_peT", [ e, t, n, s ]));
    const r = !ze;
    const i = r && Vd();
    const c = i ? (() => Gf().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && na(() => t.fallback$ != null) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Oc(kd, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = t.fallback$ ? t.fallback$.getFn(Gf())() : null;
    const p = i ? /*#__PURE__*/ Gs(Gd, {
        boundary: f,
        fallbackStyle: Oc(Sd, [ t, n, o, s ], Yd),
        showFallback: u,
        state: n
    }, null, d, 1, null) : /*#__PURE__*/ Gs("div", {
        style: Oc(Sd, [ t, n, o, s ], Yd)
    }, null, d, 1, null);
    return [ p, 
    /*#__PURE__*/ Gs("div", null, i ? {
        [Nd]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ Gs(i ? Zd : uo, i ? {
        [Hr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Hr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Td = /*#__PURE__*/ Oa(
/*#__PURE__*/ Tc(Pd, "_peC"));

const Gd = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ jd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ Gs("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const Zd = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ jd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.catchBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, kf) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ Gs(uo, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ Gs(uo, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${pr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Ud(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Mt) {
            return l.Mt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const Ad = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = qd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return Gs("script", null, o, null, 0, "prefetch-service-worker");
};

const qd =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Id = () => null;

globalThis.__qwik && er(30, [ globalThis.__qwik, rr ]);

globalThis.__qwik = rr;

export { Ia as $, fd as Catch, dd as Each, oo as Fragment, vf as NoSerializeSymbol, Td as Pending, Id as PrefetchGraph, Ad as PrefetchServiceWorker, lo as RenderOnce, Bc as Resource, Ed as Reveal, ao as SSRComment, fo as SSRRaw, po as SSRStream, ho as SSRStreamBlock, bf as SerializerSymbol, wd as Show, co as SkipRender, uo as Slot, Ui as _CONST_PROPS, Hf as _DomContainer, yi as _EFFECT_BACK_REF, Xr as _ELEMENT_SEQ, Gi as _EMPTY_ARRAY, Zi as _EMPTY_OBJ, Ji as _IMMUTABLE, jc as _SharedContainer, js as _SubscriptionData, ec as _SubscriptionPatch, ku as _Task, Yi as _UNINITIALIZED, Bi as _VAR_PROPS, re as _addProjection, cd as _caC, ld as _caR, ma as _captures, v as _chk, we as _createDeserializeContainer, Sa as _createQRL, Nn as _createStore, di as _delay, $e as _deserialize, vc as _dumpState, hd as _eaC, ad as _eaT, yn as _executeSsrChores, Oc as _fnSignal, ss as _getConstProps, la as _getContextContainer, oa as _getContextEvent, sa as _getContextHostElement, Ie as _getDomContainer, xe as _getQContainerElement, w as _getSubscriber, is as _getVarProps, Yn as _handleSSRError, k as _hasSlotProps, Wu as _hasStoreEffects, Kc as _hmr, Es as _injectAsyncSignalValue, je as _invoke, Ds as _isJSXNode, zu as _isStore, Un as _isStringifiable, Ru as _isTask, ua as _jsxBranch, Ks as _jsxC, no as _jsxQ, to as _jsxS, Gs as _jsxSorted, Zs as _jsxSplit, ii as _mapApp_findIndx, oi as _mapArray_get, si as _mapArray_set, Ou as _markSignalAsExternallyOwned, Xe as _newInvokeContext, Ac as _noopQrl, qc as _noopQrlDEV, Pd as _peC, Rd as _peT, Wn as _preprocessState, Ca as _qrlSync, Ln as _qrlToString, Ic as _qrlWithChunk, Mc as _qrlWithChunkDEV, gd as _reC, bd as _reR, _d as _reT, Cc as _regSymbol, oe as _removeProjection, b as _res, Sf as _resolveContextWithoutSequentialScope, bo as _restProps, t as _retryOnPromise, zc as _rsc, C as _run, pe as _serialize, te as _setEvent, ie as _setProjectionTarget, yd as _shC, $d as _shT, Mn as _task, se as _updateProjectionProps, ee as _useHmr, m as _val, df as _verifySerializable, Sl as _vnode_ensureElementInflated, du as _vnode_getAttrKeys, Bl as _vnode_getElementName, Jl as _vnode_getFirstChild, vl as _vnode_getProp, Il as _vnode_getVNodeForChildNode, Dl as _vnode_insertBefore, dl as _vnode_isElementVNode, $l as _vnode_isMaterialized, yl as _vnode_isTextVNode, wl as _vnode_isVirtualVNode, al as _vnode_newVirtual, zl as _vnode_remove, bl as _vnode_setProp, kn as _vnode_toString, ca as _waitUntilRendered, Qn as _walkJSX, xs as _wrapProp, Cs as _wrapSignal, Fa as component$, Oa as componentQrl, ks as createAsyncQrl, Ts as createComputed$, Ss as createComputedQrl, _f as createContextId, _ as createElement, As as createSerializer$, Rs as createSerializerQrl, Ps as createSignal, Xa as event$, xa as eventQrl, Du as forceStoreEffects, Da as getClientManifest, Ie as getDomContainer, Ce as getLocale, ri as getPlatform, _ as h, bs as implicit$FirstArg, Tc as inlinedQrl, Nc as inlinedQrlDEV, Ue as isDev, Tu as isSignal, ro as jsx, io as jsxDEV, so as jsxs, mf as noSerialize, Pc as qrl, xc as qrlDEV, Wa as render, ei as setPlatform, Na as sync$, na as untrack, Vu as unwrapStore, Yh as useComputed$, Jh as useComputedQrl, Vo as useConstant, Ef as useContext, gf as useContextProvider, Ua as useId, Vc as useLexicalScope, Hc as useOn, Jc as useOnDocument, Yc as useOnWindow, rd as useResource$, Uc as useResourceQrl, Kh as useSerializer$, Zh as useSerializerQrl, De as useServerData, Wo as useSignal, Va as useStore, zh as useStyles$, Vh as useStylesQrl, Bh as useStylesScoped$, Uh as useStylesScopedQrl, id as useTask$, Eu as useTaskQrl, sd as useVisibleTask$, td as useVisibleTaskQrl, rr as version, Oe as withLocale };
